import React, { Component } from 'react';

import { buildPath } from '../utils/route_utils.js'
import { updateSEO } from '../utils/seo_utils'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import WordSec from '../components/WordSec'
import ListSec from '../components/ListSec'
import SlideShow from '../components/SlideShow'
import PicWordSec from '../components/PicWordSec'
import WordPicSec from '../components/WordPicSec'
import SelfIntro from '../components/SelfIntro'
import NewsItem from '../components/NewsItem'
import FiveWItem from '../components/FiveWItem'
import IconWord from '../components/IconWord'
import PartnerSec from '../components/PartnerSec'
import PicDisplay from '../components/PicDisplay'
import PicWordWithBtn from '../components/PicWordWithBtn'
import WordBtn from '../components/WordBtn'
import LogoWall from '../components/LogoWall'
import AnnouncementBanner from '../components/AnnouncementBanner'
import Breadcrumb from '../components/Breadcrumb'

import '../css/old_web.css';


class GeneralPage extends Component {

  constructor(props) {
    super(props);

    // Extract page from URL path: /:lang/about/:page
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const pageId = pathParts.length >= 3 ? pathParts[2] : (pathParts.length >= 2 ? pathParts[1] : 'about_us');

    this.state = {
      web_content: [],
      lang: this.props.lang,
      id: pageId
    }

    this.get_data = this.get_data.bind(this)
    this.navigate = this.navigate.bind(this)
    this.update_lang = this.update_lang.bind(this)
  }

  componentDidMount() {
    this.get_data(this.state.id)
    updateSEO(this.state.id, this.state.lang, '/about/' + this.state.id);
  }

  openInNewTab(url) {
        var win = window.open(url, '_blank');
        if (win != null) {
            win.focus();
        }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }


  render() {

        const pageLabels = {
          about_us: { zh: "關於我們", en: "About Us", ja: "会社について" },
          core_technology: { zh: "核心技術", en: "Core Technology", ja: "コア技術" },
          career: { zh: "職業機會", en: "Career", ja: "キャリア" },
          intern: { zh: "實習計畫", en: "Internship", ja: "インターンシップ" },
          softwareIntern: { zh: "軟體開發實習", en: "Software Internship", ja: "ソフトウェアインターンシップ" },
          hardwareIntern: { zh: "硬體設計開發實習", en: "Hardware Internship", ja: "ハードウェアインターンシップ" },
          internSE2022Spring: { zh: "軟體實習心得 — Brian Wang", en: "Software Intern — Brian Wang", ja: "ソフトウェアインターン — Brian Wang" },
          internSE2022Spring_wu: { zh: "軟體實習心得 — Xianglin Wu", en: "Software Intern — Xianglin Wu", ja: "ソフトウェアインターン — Xianglin Wu" },
          internME2022Spring: { zh: "硬體實習心得", en: "Hardware Intern Experience", ja: "ハードウェアインターン体験" },
          "SE-robot": { zh: "機器人軟體工程師", en: "Robot Software Engineer", ja: "ロボットソフトウェアエンジニア" },
          "SE": { zh: "AI軟體工程師", en: "AI Software Engineer", ja: "AIソフトウェアエンジニア" },
          "SD": { zh: "事業發展專員", en: "Sales/Business Development", ja: "営業/事業開発" },
          "HW-robot": { zh: "機器人硬體設計工程師", en: "Robot Hardware Design Engineer", ja: "ロボットハードウェア設計エンジニア" },
          environment: { zh: "工作環境", en: "Environment", ja: "職場環境" },
          news: { zh: "最新消息", en: "News", ja: "ニュース" },
          colab_flow: { zh: "合作流程", en: "Collaboration", ja: "協力フロー" },
          security_policy: { zh: "安全政策", en: "Security Policy", ja: "セキュリティポリシー" },
        };
        const currentLabel = pageLabels[this.state.id] || { zh: this.state.id, en: this.state.id, ja: this.state.id };
        const breadcrumbItems = [{ label: currentLabel }];

        return (
            <div id="body">
              <AnnouncementBanner lang={this.state.lang} />
              <Navbar lang={this.state.lang} updateLangFunc={this.update_lang} />
              <Breadcrumb lang={this.state.lang} items={breadcrumbItems} />

              <div className="main_section">


                {this.state.web_content.map((item, index) => {
                  if (item["type"] === "word_section") {
                    return (<WordSec key={index} className="general_section" title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} style={item["style"]} />)
                  }
                  else if (item["type"] === "list_section") {
                    return (<ListSec key={index} action={item["action"]} className="general_section" title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} main_title={item["main_title"][this.state.lang]} />)
                  }

                  else if (item["type"] === "word_btn") {
                      return (<WordBtn key={index} action={item["action"]} className="general_section" title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} style={item["style"]} />)
                    }

                  else if (item["type"] === "slide_show") {
                    return (<SlideShow lang={this.state.lang} key={index} title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} action={item["action"]} img={item["img"]} img_num={item["img_num"]} arrow_flag={item["arrow_flag"]} logo_flag={item["logo_flag"]}/>)
                  }

                  else if (item["type"] === "pic_word_section") {
                    return (<WordPicSec key={index} className="general_section" img={item["img"]} title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} style={item["style"]}/>)
                  }

                  else if (item["type"] === "word_pic_section") {
                    return (<PicWordSec key={index} className="general_section" img={item["img"]} title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} style={item["style"]}/>)
                  }

                  else if (item["type"] === "self_intro") {
                    return (<SelfIntro key={index} className="general_section" content={item["content"]} />)
                  }

                  else if (item["type"] === "news_item") {
                    return (<NewsItem key={index} className="general_section" content={item["content"]} lang={this.state.lang} />)
                  }

                  else if (item["type"] === "five_w_item") {
                    return (<FiveWItem key={index} className="general_section" title={item["title"][this.state.lang]} content={item["content"][this.state.lang]} />)
                  }

                  else if (item["type"] === "title_section") {
                    return (<div key={index} className="title_section_holder"><h1 dangerouslySetInnerHTML={{__html: item["title"][this.state.lang]}} /></div>)
                  }

                  else if (item["type"] === "partner_section") {
                    return (<PartnerSec key={index} img={item["img"]} title={item["title"][this.state.lang]} action={item["action"]}/>)
                  }

                  else if (item["type"] === "pic_display") {
                    return (<PicDisplay key={index} img={item["img"]} title={item["title"][this.state.lang]} style={item["style"]}/>)
                  }

                  else if (item["type"] === "icon_word") {
                    return (<div key={index} style={(item["style"]["div"] ? item["style"]["div"] : "")} className="icon_word_holder">
                              {item["title"][this.state.lang].map((title, i) => (<IconWord key={i} style={item["style"]} img={item["img"][i]} title={title}/>))}
                            </div>)
                  }

                  else if (item["type"] === "logowall") {
                    return (<LogoWall />)
                  }

                  else if (item["type"] === "pic_with_btn") {
                    return (<div className="main_product_holder">
                            {item["title"][this.state.lang].map((item_title, item_i) => (
                                <PicWordWithBtn 
                                  key={item_i}
                                  lang={this.state.lang}
                                  img={item["img"][item_i]}
                                  title={item_title} 
                                  content={item["content"][this.state.lang][item_i]}
                                  action={item["action"][item_i]} />
                              ))}
                          </div>)
                  }

                })}

                
              </div>

              <Footer lang={this.state.lang} navigate={this.navigate}/>

            </div>

        );}



  get_data(page_title) {
    const intern_content = {
    "about_us": {
      "web_content": [{
        "type": "slide_show",
        "action": [""],
        "title": {"en": ["About us"], "zh": ["公司理念"], "ja": ["Nexuni について"]},
        "content": {"en": [""], "zh": [""], "ja": [""]},
        "img_num": "1",
        "arrow_flag": false,
        "logo_flag": true,
        "img": ["image/about_photo.jpg"]
      },{
        "type": "word_section",
        "title": {
          "ja": ["AIロボットを現実世界に導入する"],
          "en": ["Bringing AI Robots into the Real World"],
          "zh": ["讓機器人真正落地上工，解決最難的自動化難題。"]},
        "content": {
          "ja": ["Nexuni Co., Ltd.（耐思尼股份有限公司）は、台湾・新竹サイエンスパークで設立され、<b style='font-weight: 800;'>実際の環境で本当に稼働できるAIロボット</b>の開発に取り組んでいます。私たちは、感知・制御・位置推定・意思決定を統合する「コアプラットフォーム方式」を採用し、ロボットが現場で安定して動作しないという業界全体の課題を解決しています。AIやロボット技術が進化している現在でも、多くの企業が「設備はあるのに、実際の作業を完了できない」という問題を抱えています。多くのロボットメーカーは、ロボットアームや移動台車、センサーなどの個別パーツだけを提供しており、導入後には「もう1枚ドアを開ける」「予想外の物を動かす」など、最後の一手に対応できず、システム全体が正しく動かないことがあります。<br/><br/>Nexuniは、AIロボットの完全な技術スタックを自社で保有しており、現場の実運用に必要なデータを集めて学習する独自の手法も確立しています。私たちのプラットフォームは、<b style='font-weight: 800;'>人手不足や危険な作業環境</b>に直面している業界向けに設計されており、溶接、警備、清掃、駐車場管理、飲食サービスなどの分野において、導入しやすく、拡張性があり、<b>現場のニーズに応じてカスタマイズできる</b>ロボット自動化ソリューションを提供しています。Nexuniのチームは、MIT、CMU、国立台湾大学、国立清華大学、国立陽明交通大学などのトップ大学出身のエンジニアや専門コンサルタントで構成されています。私たちは、高度なAIとロボティクスに、シンプルさ・信頼性・安全性を組み合わせることで、現場で本当に使えるロボットを実現しています。<br/><br/>私たちは、単なる設備ではなく、「現場で機能する完全なソリューション」を提供します。<br/><br/><b style='font-weight: 800;'><< Nexuni AI Robots, Ready to Work. >></b>"],
          "en": ["Nexuni Co., Ltd., founded in Taiwan's Hsinchu Science Park, is committed to building <b style='font-weight: 800;'>AI robots that can truly be deployed in real-world </b>environments. Using a core platform approach, we integrate perception, control, localization, and decision-making to solve a key industry challenge: making robots work reliably outside the lab. Although AI and robotics technologies have matured, many companies still face the challenge of having equipment that is available but not capable of completing real tasks. Most robot manufacturers offer only individual components such as robotic arms, mobile bases, or sensors. When deployed, these systems often fail due to a lack of flexibility for handling the final, task-specific actions, like opening an extra door or moving an unexpected object.<br/><br/>At Nexuni, we own the complete technology stack for AI robotics and have developed a comprehensive data collection methodology that enables robots to learn from and adapt to real-world customer environments. Our platform is designed for <b style='font-weight: 800;'>industries facing labor shortages and high-risk conditions</b>. We provide deployable, scalable, and easily customizable robotic automation solutions for sectors such as welding, security, cleaning, parking management, and food service.Our team includes top engineers and expert consultants from institutions such as MIT, CMU, National Taiwan University, National Tsing Hua University, and National Yang Ming Chiao Tung University. By combining advanced AI and robotics with a focus on simplicity, reliability, and safety, we deliver robots that are truly ready for the field.<br/><br/>We don't just provide equipment. We deliver complete solutions that work.<br/><br/><b style='font-weight: 800;'><< Nexuni AI Robots, Ready to Work. >></b>"],
          "zh": ["Nexuni 耐思尼股份有限公司成立於台灣新竹科學園區，致力於打造<b style='font-weight: 800;'>真正能落地的 AI 機器人</b>。我們以核心平台的思維整合感知、控制、定位與決策能力，打破市面上機器人難以導入實際場域的困境。在 AI 與機器人技術日益成熟的時代，許多企業仍面臨「買得到設備，卻無法完成任務」的挑戰。市面上多數機器人廠商僅提供單一元件（如手臂、機器人底盤或感測器），實際部署時常因缺乏對「最後一段動作」的客製化彈性（例如多開一道門、多搬一個物件），導致整體方案無法真正上線運作。<br/><br/>Nexuni 掌握 AI 機器人完整的核心技術，並擁有一套完善的機器人資料搜集方法，能夠深入學習並理解客戶實際場域的工作需求，確保機器人成功落地。我們的平台專為<b style='font-weight: 800;'>高危險、缺工產業</b>設計，針對焊接、安保、清潔、停車場與餐飲等高勞動強度場域，提供可落地、可擴充、可快速客製的機器人自動化解決方案，協助業主提升效率並減少對人力的依賴。我們集結來自 MIT、CMU、台大、清大、交大等國際頂尖人才與科技顧問團隊，融合 AI、機器人與自動化技術，秉持「簡單、可靠、安全」三大核心價值，致力於打造能真正解決問題、走入現場的 AI 機器人。<br/><br/>我們不只是販售設備，而是交付能真正上工的解決方案。<br/><br/><b style='font-weight: 800;'><< Nexuni AI Robots, Ready to Work. >></b>"]}
      }]
    },
    "core_technology": {
      "web_content": [{
        "type": "slide_show",
        "action": [""],
        "title": {"en": ["Core Technology"], "zh": ["核心技術"], "ja": ["技術"]},
        "content": {"en": [""], "zh": [""], "ja": [""]},
        "img_num": "1",
        "arrow_flag": false,
        "logo_flag": true,
        "img": ["image/home2.jpg"]
      },
      {
        "type": "icon_word",
        "style": {"div": {paddingTop: "0px"}, "text": {}, "img": {}},
        "title": {
          "ja": ["コア技術の優位性", "技術実現戦略", "市場への柔軟な応用力"],
          "en": ["Core Technical Advantages", "Technology Implementation Strategy", "Market Application Flexibility"],
          "zh": ["核心技術優勢", "技術實現策略", "市場應用靈活性"]
        },
        "img": ["core.png", "strategy.png", "market.png"]
      },
      {
        "type": "word_section",
        "title": {
          "ja": ["自社開発プラットフォーム"],
          "en": ["Proprietary AI Platform"],
          "zh": ["自研核心平台"]},
        "style": {"div": {width: '100%'}, "h3": {}, "h4": {'text-align': 'left'}},
        "content": {
          "zh": [
            "自建完整機器人控制架構，整合感測器數據、運動控制、定位與路徑規劃。支援視覺 SLAM、RTK GPS、IMU 融合等多種定位技術，適應室內外多變環境。<br/><br/>透過多感測器同步紀錄（RGBD、LiDAR、IMU 等）還原現場狀況，建立高品質訓練資料，加速 AI 模型優化。支援場域適應與模擬訓練。"
          ],
          "en": [
            "In-house robotic control architecture integrating sensor data, motion control, localization, and path planning. Supports visual SLAM, RTK GPS, and IMU fusion for dynamic indoor and outdoor environments.<br/><br/>Multi-sensor synchronized logging (RGBD, LiDAR, IMU) reconstructs site conditions to build high-quality training datasets. Supports domain adaptation and simulation-based training."
          ],
          "ja": [
            "センサー情報、モーション制御、位置推定、経路計画を統合するロボット制御構造を自社開発。視覚 SLAM、RTK GPS、IMU 融合など複数技術に対応し、多様な環境で運用可能。<br/><br/>RGBD、LiDAR、IMU によるマルチセンサー記録で現場を再現し、高品質な学習データを構築。現場適応やシミュレーション訓練にも対応。"
          ]
        }
      },
      {
        "type": "word_section",
        "title": {
          "ja": ["エッジ AI と軽量モデル"],
          "en": ["Edge AI & Lightweight Models"],
          "zh": ["邊緣 AI 與輕量化模型"]},
        "style": {"div": {width: '100%'}, "h3": {}, "h4": {'text-align': 'left'}},
        "content": {
          "zh": [
            "採用 TinyML、模型剪枝與量化技術，將 AI 模型部署於邊緣裝置即時推論。整合 NVIDIA TensorRT、ISAAC 等框架，實現低延遲控制與即時感知。AI 模型支援區域自適應學習，自動調整參數以適應不同環境。"
          ],
          "en": [
            "TinyML, model pruning, and quantization enable real-time inference on edge devices. Integrated with NVIDIA TensorRT and ISAAC for low-latency control and real-time perception. Models support local adaptive learning, automatically adjusting to environmental conditions."
          ],
          "ja": [
            "TinyML、プルーニング、量子化でモデルを軽量化し、エッジデバイスでリアルタイム推論を実行。NVIDIA TensorRT・ISAAC と統合し、低遅延の制御と即時認識を実現。環境に応じた自動パラメータ調整にも対応。"
          ]
        }
      },
      {
        "type": "word_section",
        "title": {
          "ja": ["柔軟な導入と統合"],
          "en": ["Flexible Deployment & Integration"],
          "zh": ["彈性部署與整合"]},
        "style": {"div": {width: '100%'}, "h3": {}, "h4": {'text-align': 'left'}},
        "content": {
          "zh": [
            "從底層韌體到上層應用皆可彈性調整，支援快速部署。模組化介面設計支援 API 開發與第三方系統串接，適用於智慧工廠、智慧建築與自動化物流等場景。"
          ],
          "en": [
            "End-to-end integration from firmware to application control, enabling rapid field deployment. Modular interface design supports API development and third-party system integration for smart factories, buildings, and logistics."
          ],
          "ja": [
            "ファームウェアからアプリケーション制御まで、エンドツーエンドで迅速な導入に対応。モジュール型設計で API 開発やサードパーティ連携をサポートし、スマート工場・ビル・物流自動化に展開可能。"
          ]
        }
      }]

    },
    "environment": {
      "web_content": [{
        "type": "slide_show",
        "action": [""],
        "title": {"en": ["Life At Nexuni"], "zh": ["文化與環境"], "ja": ["企業文化"]},
        "content": {"en": [""], "zh": [""], "ja": [""]},
        "img_num": "1",
        "arrow_flag": false,
        "logo_flag": true,
        "img": ["image/life.jpg"]
      },{
        "type": "pic_with_btn",
        "action": ["", "", "", ""],
        "img": ["life_main.jpg", "safety_ethics.jpg", "environment_1.jpg", "life_last.jpg"],
        "title": {
          "ja": ["創新", "実務経験からの学習", "共に成長する", "Nexuniファミリー"],
          "en": ["Innovation", "Learning through Hands-on Experience","Personal and Professional Growth","Nexuni Family"], 
          "zh": ["創新", "實務經驗學習","共同成長","Nexuni大家庭"]},
        "content": {"ja": [
                          "ロボットと AI の可能性を日々の実験で切り拓く。革新は概念ではなく、日常業務そのものです。",
                          "全員がフロントラインに立ち、実際の課題から学ぶ。実践こそが最高の教育です。",
                          "自由と柔軟性を重視し、個々のキャリアに合わせた職務調整で共に成長します。",
                          "同じビジョンを持つ仲間が集まり、快適で力を与える環境を共に創ります。"],
                    "en": [
                          "We explore the limits of robotics through constant experimentation. Innovation isn't a concept here — it's daily work.",
                          "Every team member works on the frontline, learning from real-world challenges. Hands-on experience is our best teacher.",
                          "We adjust roles to match individual strengths and career goals. Freedom, flexibility, and cross-disciplinary growth define our culture.",
                          "Nexuni brings everybody together. Same vision, same ambition — building a community where people feel empowered."],
                    "zh": [
                          "透過持續實驗探索機器人與 AI 的極限。在這裡，創新不只是理念，更是日常工作的一部分。",
                          "每位員工都有機會直接參與前線工作，從真實挑戰中學習成長。實務操作是我們最好的老師。",
                          "根據個人專業與職涯發展靈活調整職務，鼓勵跨領域整合與創新，實現個人與企業共同成長。",
                          "Nexuni 連結所有人。相同的遠見與企圖心，打造一個舒適且激勵人心的環境。"]}
      }]

    },
    "security_policy": {
        "web_content": [{
            "type": "slide_show",
            "action": [""],
            "title": {
                "en": ["Information Security Policy"],
                "zh": ["資訊安全政策"],
                "ja": ["情報セキュリティ方針"]
            },
            "content": {
                "en": [""],
                "zh": [""],
                "ja": [""]
            },
            "img_num": "1",
            "arrow_flag": false,
            "logo_flag": true,
            "img": ["image/software_intern_intro.png"]
        },{
            "type": "word_section",
            "title": {
                "ja": ["目的（方針）"],
                "en": ["Purpose (Policy)"],
                "zh": ["目的(政策)"]
            },
            "content": {
                "ja": [
                    "株式会社耐思尼（以下「当社」）は、情報データ、システム、機器およびネットワーク通信の安全性を確保し、人的ミス、悪意ある行為または自然災害によって発生する情報資産の盗難、不正使用、漏洩、改ざんまたは損壊のリスクを効果的に低減するために、情報セキュリティ管理システムを構築し、情報セキュリティ方針（以下「本方針」）を制定しています。本方針は、情報の機密性、完全性、可用性を確保することを目的としています。\n\n1. 機密性：許可された者のみが機密情報にアクセスできることを保証します。\n\n2. 完全性：使用される情報が正確で改ざんされていないことを保証します。\n\n3. 可用性：許可されたユーザーが必要なときに情報および関連情報資産にいつでもアクセスできることを保証します。"
                ],
                "en": [
                    "Nexuni Co., Ltd. (hereinafter referred to as the 'Company') establishes this Information Security Policy (hereinafter referred to as the 'Policy') to ensure the security of information data, systems, equipment, and network communications. This policy aims to effectively reduce the risk of information assets being stolen, misused, leaked, altered, or damaged due to human error, intentional acts, or natural disasters, by establishing an information security management system. The goal is to ensure the confidentiality, integrity, and availability of information.\n\n1. Confidentiality: Ensure that only authorized individuals can access sensitive information.\n\n2. Integrity: Ensure that the information in use is accurate and has not been altered.\n\n3. Availability: Ensure that authorized users can access information and related information assets at any time as needed."
                ],
                "zh": [
                    "耐思尼股份有限公司(以下簡稱本公司)為確保資訊資料、系統、設備及網路通訊安全, 有效降低因人為疏失、蓄意或天然災害等導致之資訊資產遭竊、不當使用、洩漏、竄改或毀損等風險,並建立資訊安全管理系統, 特訂定資訊安全政策(以下簡稱本政策), 以確保資訊之機密性、完整性與可用性。\n\n一、機密性:確保只有經授權的人才能存取機敏資訊。\n\n二、完整性:確保使用之資訊正確無誤、未遭竄改。\n\n三、可用性:確保經授權的使用者在需要時可以隨時存取資訊及相關資訊資產。"
                ]
            }
        },{
            "type": "word_section",
            "title": {
                "ja": ["Cookie と分析"],
                "en": ["Cookies & Analytics"],
                "zh": ["Cookie 與分析"]
            },
            "content": {
                "ja": [
                    "当ウェブサイトでは、サイトの運営、および訪問者がサイトをどのように利用しているかを把握するために Cookie を使用しています。\n\n<b style='font-weight: 800;'>必須 Cookie：</b>言語設定や Cookie 同意の選択を記憶するなど、基本的な機能に必要なもので、常に有効です。\n\n<b style='font-weight: 800;'>分析 Cookie：</b>Cookie バナーで「同意する」を選択した場合にのみ、Google Analytics によって設定されます。ページビューや利用された機能の測定に役立ち、サイト改善のために使用します。Google Analytics は IP アドレスからおおよその位置（国・地域・都市）を推定する場合がありますが、IP アドレスは匿名化され、分析を通じて氏名や連絡先を収集することはありません。\n\n<b style='font-weight: 800;'>お客様の選択：</b>バナーからいつでも分析 Cookie を拒否できます。拒否した場合、分析 Cookie は保存されません。後で選択を変更する場合は、ブラウザで当サイトの Cookie を削除し、ページを再読み込みすると再びバナーが表示されます。\n\nデータの取り扱いに関するご質問は、お問い合わせページよりご連絡ください。"
                ],
                "en": [
                    "This website uses cookies to operate and to understand how visitors use our site.\n\n<b style='font-weight: 800;'>Essential cookies</b> are required for basic functionality, such as remembering your preferred language and your cookie-consent choice. These are always active.\n\n<b style='font-weight: 800;'>Analytics cookies</b> are set by Google Analytics only after you click \"Accept\" on our cookie banner. They help us measure page views and which features are used so we can improve the site. Google Analytics may infer an approximate location (country, region, city) from your IP address; IP addresses are anonymized, and we do not collect your name or contact details through analytics.\n\n<b style='font-weight: 800;'>Your choices:</b> You can decline analytics cookies at any time using the banner; if you decline, no analytics cookies are stored. To change your decision later, clear this site's cookies in your browser and reload the page to see the banner again.\n\nFor any questions about how we handle your data, please contact us through our Contact page."
                ],
                "zh": [
                    "本網站使用 Cookie 以維持網站運作，並了解訪客如何使用本網站。\n\n<b style='font-weight: 800;'>必要性 Cookie：</b>用於基本功能，例如記住您偏好的語言與您的 Cookie 同意選擇，這類 Cookie 將持續啟用。\n\n<b style='font-weight: 800;'>分析型 Cookie：</b>僅在您於 Cookie 提示中點選「接受」後，才會由 Google Analytics 設定。這些 Cookie 協助我們衡量頁面瀏覽與功能使用情況，以改善網站。Google Analytics 可能依您的 IP 位址推估約略位置（國家、地區、城市）；IP 位址會被匿名化，我們不會透過分析工具收集您的姓名或聯絡資料。\n\n<b style='font-weight: 800;'>您的選擇：</b>您可隨時透過提示列拒絕分析型 Cookie；若拒絕，將不會儲存任何分析型 Cookie。若日後想變更決定，請於瀏覽器中清除本網站的 Cookie 並重新整理頁面，即可再次看到提示列。\n\n如對我們處理您資料的方式有任何疑問，請透過「聯絡我們」頁面與我們聯繫。"
                ]
            }
        }]
    },
    "colab_flow": {
      "web_content": [{
        "type": "slide_show",
        "action": [""],
        "title": {"ja": ["協力方法"], "en": ["How to Collaborate?"], "zh": ["合作流程"]},
        "content": {"ja": [""], "en": [""], "zh": [""]},
        "img_num": "1",
        "arrow_flag": false,
        "logo_flag": true,
        "img": ["image/5w_pic.jpg"]
      },
      {
        "type": "word_section",
        "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
        "content": {
          "ja": [""],
          "en": [""],
          "zh": [""]},
        "title": {
          "ja": [""],
          "en": [""],
          "zh": [""]}
      },
      {
        "type": "word_section",
        "style": {"div": {width: '85%'}, "h3": {'font-weight': '500'}, "h4": {}},
        "title": {
          "ja": [""],
          "en": [""],
          "zh": [""]},
        "content": {
          "ja": ["Nexuni は AI ロボット自動化技術に特化し、人手不足や高リスク作業といった課題の解決を企業に提供しています。スマートロボットを活用することで、業務効率と現場の安全性を総合的に向上させます。当社のシステムは、工場、マンション、駐車場など、さまざまな現場で活用されており、場面に応じたモジュール式かつカスタマイズ可能な自動化ソリューションを提供します。<br/><br/>ロボット導入の流れは、適切な製品の選定から始まります。お客様は Nexuni の製品カタログを参考にニーズに合ったソリューションを選び、その後、弊社にご連絡いただき、相談の予約をしていただきます。専門チームがニーズの確認と現場調査を行い、最適な見積もりとシステム計画をご提案します。確認が完了すると、設置統合および操作トレーニングを実施し、お客様が迅速にスマート自動化システムを導入できるようサポートします。"],
          "en": ["Nexuni focuses on AI robotic automation technology, helping businesses address challenges such as labor shortages and high-risk operations. By leveraging intelligent robots, we enhance operational efficiency and on-site safety across various industries. Our systems are widely used in factories, residential communities, and parking facilities, offering modular and customizable automation solutions tailored to each environment.<br/><br/>The collaboration process begins with choosing the suitable product. Customers can refer to the Nexuni product catalog to choose a suitable solution based on their needs, then schedule a consultation with us. Our expert team will assess the site and confirm the requirements, providing the optimal quotation and system plan. Once confirmed, we proceed with installation, system integration, and operational training to help customers quickly deploy their intelligent automation system."],
          "zh": ["Nexuni 專注於 AI 機器人自動化技術，致力於協助企業解決人力短缺與高風險作業的挑戰，透過智慧機器人全面提升營運效率與現場安全。我們的系統廣泛應用於工廠、公寓社區、停車場等多種場域，能針對不同場景提供模組化與客製化的自動化解決方案。<br/><br/>合作導入流程從選擇適合的產品開始。客戶可參考 Nexuni 產品型錄，依據需求選定合適的解決方案，接著與我們預約諮詢時間，由專業團隊進行需求確認與場域評估，進而提供最適報價與系統規劃。完成確認後，即安排安裝整合與操作訓練，協助客戶快速啟用智慧自動化系統。"]
        },
      },
      {
        "type": "word_section",
        "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
        "content": {
          "ja": [""],
          "en": [""],
          "zh": [""]},
        "title": {
          "ja": ["協力プロセス"],
          "en": ["Collaboration Process"],
          "zh": ["合作流程"]}
      }
      ,{
        "type": "icon_word",
        "style": {"div": {paddingTop: "0px"}, "text": {}, "img": {}},
        "title": {
          "ja": ["興味のあるソリューションを選択し、私たちに連絡してください。", "要件を確認するための会議や訪問を予約してください。", "要件に基づいて見積もりをお送りします。", "両者が合意したスケジュールに沿ってシステムの設置と統合を行います。"],
          "en": ["Identify the solutions of your interests and contact us.", "Schedule a meeting or visit to confirm requirements.", "We will send a quotation based on your requirements.", "System installation and integration according to the timeline that both sides agreed on. "],
          "zh": ["選擇有興趣的產品並聯絡我們", "預約會議或參訪以確認需求", "我們會根據需求回傳報價", "根據合作專案時程做系統安裝整合"]},
        "img": ["s_logo_1.png", "s_logo_2.png", "s_logo_3.png", "s_logo_4.png"]
      },
      {
        "type": "word_section",
        "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
        "content": {
          "ja": [
            "<b style='font-weight: 800;'>1. お客様が Nexuni に連絡し、スマート溶接ロボットソリューションの導入と利点について相談</b><br/>対象となるのは、金属加工工場や溶接の受託業者で、人手不足や自動溶接のニーズを抱えているお客様です。Nexuni に連絡し、自動化溶接による改善方法について相談します。<br/>\n<b style='font-weight: 800;'>2. Nexuni の営業・技術チームがミーティングを設定し、溶接プロセスのヒアリングと現場ニーズを評価</b><br/>溶接対象（例：ドアフレーム、筐体、構造部品など）、ワークサイズや誤差範囲、使用中の溶接機、溶接経路の変動、既存の協働ロボットの有無などを確認します。プロセスが複雑な場合には、Nexuni が現地調査も実施します。<br/>\n<b style='font-weight: 800;'>3. 評価結果に基づき、スマート溶接システムの統合ソリューションと見積を提示</b><br/>レーザーセンサー、協働ロボットの選定、溶接パラメータの提案、制御インターフェースの統合など、要件に応じたモジュール統合を提供し、ハードウェア・ソフトウェアの統合とトレーニングを行います。<br/>\n<b style='font-weight: 800;'>4. お客様が導入を決定後、Nexuni がシステムの設置と操作トレーニングを実施</b><br/>現場設置完了後、実機を用いた操作指導を行い、自動溶接プロセスの構築をサポートします。システムは Nexuni AI の継続学習機能を活用し、経路補正や溶接パラメータを自動最適化していきます。"
          ],
          "en": [
            "<b style='font-weight: 800;'>1. Customer contacts Nexuni to learn about the benefits and applications of the smart welding robot solution</b><br/>Ideal for metal processing factories or contract welding companies facing labor shortages or seeking automated welding. Customers reach out to Nexuni to explore how smart welding can improve their operations.<br/>\n<b style='font-weight: 800;'>2. Nexuni's sales and technical teams schedule a meeting to understand the welding process and assess site requirements</b><br/>This includes reviewing the types of weldments (e.g., door frames, enclosures, structural parts), workpiece size and tolerances, welding machine models, variation in welding paths, and whether a collaborative robot is already in use. For complex workflows, Nexuni can provide on-site assessments to support planning.<br/>\n<b style='font-weight: 800;'>3. Based on actual needs and assessment results, Nexuni proposes a complete smart welding system and quotation</b><br/>We provide modular system integration including laser sensing, cobot selection, welding parameter suggestions, and control interface integration. A complete hardware-software solution and after-sales training are also included.<br/>\n<b style='font-weight: 800;'>4. Once the customer confirms the partnership, Nexuni installs the system and conducts user training</b><br/>After installation, Nexuni provides hands-on training to help the customer establish a robust automated welding process. With continuous learning powered by Nexuni AI, the system keeps optimizing welding paths and parameters over time to improve productivity."
          ],
          "zh": [
            "<b style='font-weight: 800;'>1. 客戶聯絡 Nexuni，了解智慧焊接機器人解決方案的應用與效益</b><br/>適用客戶為金屬加工廠或焊接代工業者，面臨焊工人力短缺或自動化焊接需求，主動聯繫 Nexuni 尋求智慧自動化焊接的可能性與改善方式。<br/>\n<b style='font-weight: 800;'>2. Nexuni 業務與技術團隊將安排會議，針對焊接流程進行了解與場域需求評估</b><br/>包括探討客戶焊接件種類（如門框、機箱、結構件等）、工件尺寸與誤差範圍、所用焊機型號、焊接軌跡變異情況，以及是否已有協作機械手臂等。若客戶流程較複雜，Nexuni 也會提供場域現勘服務，以利後續規劃。<br/>\n<b style='font-weight: 800;'>3. 根據實際需求與評估結果，提供智慧焊接系統的完整解決方案與報價</b><br/>Nexuni 可依據客戶需求進行模組整合，包含雷射感測、協作手臂選型、焊接參數建議與控制介面整合，並提供軟硬體整合方案與售後訓練服務。<br/>\n<b style='font-weight: 800;'>4. 客戶確認合作後，由 Nexuni 進行系統導入與使用訓練</b><br/>現場安裝完成後將安排實機操作教學，協助客戶建立自動焊接流程。系統會透過 Nexuni AI 持續學習功能持續優化路徑校正與焊接參數，讓生產效能隨時間持續提升。"
          ]
        },
        "title": {
          "ja": ["協力例"],
          "en": ["Collaboration Example"],
          "zh": ["合作範例 (以智慧焊接機器人為例）"]}
      },
      {
        "type": "word_section",
        "style": {"div": {'padding-top': '20px'}, "h3": {'text-align': 'center'}, "h4": {}},
        "title": {"en": ["Customer & Partners"], "zh": ["客戶與合作夥伴"], "ja": ["顧客とパートナー"]},
        "content": {
          "en": ["Below are our valued partners and customers who have collaborated with Nexuni. We highly value these partnerships as they have propelled our business forward, not only enhancing operational efficiency but also achieving more intelligent and automated management. Through our joint efforts, we look forward to continuing to drive innovation and progress in the industry."],
          "zh": ["以下是與Nexuni攜手合作的尊貴夥伴和客戶。我們非常珍視這些合作關係，因為正是這些合作推動了我們的業務向前發展，不僅提升了運營效率，也實現了更加智慧化和自動化的管理。透過我們的共同努力，我們期待繼續推動業界的創新與進步。"],
          "ja": ["以下はNexuniと協力している尊敬されるパートナーおよび顧客です。これらの協力関係を非常に重視しています。なぜなら、それらが私たちのビジネスを前進させ、運営の効率を向上させるだけでなく、より賢く自動化された管理を実現しているからです。共同の努力を通じて、産業の革新と進歩を引き続き推進していくことを期待しています。"]
        }
      },
      {
        "type": "logowall"
      }
    ]

    },"intern": {
      "web_content": [{
        "type": "slide_show",
        "action": [""],
        "title": {"en": ["Internship"], "zh": ["實習生計畫"], "ja": ["インターンシッププログラム"]},
        "content": {"en": [""], "zh": [""], "ja": [""]},
        "img_num": "1",
        "arrow_flag": false,
        "logo_flag": true,
        "img": ["image/intern.jpg"]
      },{
        "type": "word_section",
        "title": {
            "en": ["Nexuni Internship Program"],
            "zh": ["Nexuni 實習生計畫"],
            "ja": ["Nexuni インターンシッププログラム"]
        },
        "content": {
            "en": ["Our interns are a part of Nexuni—involved and solving problems from the basics. We welcomed students with little to no experience to participate in our internship program. Currently, Nexuni provides two types of intern opportunities: software engineer intern and hardware engineer intern. The internship program usually takes place in the summer, but inquiries can be made for special circumstances. To receive our latest information for the internship program, please email contact@nexuni.com to request joining our mailing list or follow us on Instagram and Facebook for the latest news."],
            "zh": ["你喜歡設計一些有趣的產品來解決人類生活中所遇到的問題嗎？我們重視科技上的創新，並透過多領域的結合，致力於透過自動化來解決人們生活中遇到的問題。因此，Nexuni特別注重每個成員解決問題的能力及想法，透過每周團隊聚會讓所有成員有機會發表及提出想法，同時也可學習如何跟多領域人才合作，一起完成專案。有別於其他實習計畫，Nexuni團隊更重視所有成員及實習生對工作的參與度及熱情，並尊重所有成員提出的每個好想法，熱烈歡迎勇於挑戰且想法創新的實習生。實習生是Nexuni很重要的一份子，完整地參與公司開發與營運的過程。我們目前提供兩種實習職位 –– 軟體開發實習與硬體設計開發實習。除了特殊需求，耐思尼將在每年一月和七月開始進行為期半年的實習生計畫，亦有提供暑期實習的選項。若想收到實習資訊通知，歡迎來信訂閱電子報 contact@nexuni.com 或透過 Instagram, Facebook與我們聯絡。"],
            "ja": ["Nexuniのインターンは、基礎から問題を解決するためにNexuniの一部となり、関わりを持ちます。経験の少ない学生も、インターンシッププログラムに参加することができます。現在、Nexuniでは2種類のインターンシップの機会を提供しています：ソフトウェアエンジニアインターンとハードウェアエンジニアインターンです。通常、インターンシッププログラムは夏に開催されますが、特別な事情がある場合は問い合わせが可能です。インターンシッププログラムに関する最新情報を受け取りたい場合は、contact@nexuni.comにメールしてメーリングリストへの登録を依頼するか、InstagramやFacebookで最新のニュースをフォローしてください。"]
        }
      },{
        "type": "pic_with_btn",
        "action": [(() => { return this.navigate('/about/softwareIntern')}),
                    (() => { return this.navigate('/about/hardwareIntern')}),
                    (() => { return this.navigate('/about/about_us')}),
                    (() => { return this.navigate('/about/environment')})],
        "img": ["software_intern_intro.png", "hardware_intern_intro.png", "about_photo.jpg", "environment_1.jpg"],
        "title": {
            "en": ["Software Internship", "Hardware Internship", "About Nexuni", "Life At Nexuni"],
            "zh": ["軟體開發實習", "硬體設計開發實習", "公司理念", "文化與環境"],
            "ja": ["ソフトウェアインターンシップ", "ハードウェアインターンシップ", "Nexuniについて", "Nexuniの生活"]
        },
        "content": {
            "en": [
                "Enroll in our software internship to be part of the development of the state-of-the-art robot, intelligent store, carpark systems and make impact from today.",
                "Enroll in our hardware internship to be part of the design of the robot platform, IOT modules, etc. The experience will be valuable to learn hands-on mechanical design skills.",
                "Nexuni Co Ltd. has been dedicated to developing technologies to aid humans on repetitive tasks and reduce the need for labor for services like restaurant operation, parking lot management, facilities management, etc. A good solution should be well-tested and accessible to humans.",
                "Nexuni brings everybody together. It is the people that fuel the innovation and the growth of Nexuni. We welcomed everyone with the same vision and ambition to join Nexuni. We aim to create a community where people feel comfortable and empowered."
            ],
            "zh": [
                "加入我們的軟體開發實習，參與開發最先進的機器人、智慧商店、停車場系統，從今天開始產生影響力。",
                "加入我們的硬體設計開發實習，參與機器人平台、物聯網模組等的設計。這將是學習實務機構設計技能的寶貴經驗。",
                "Nexuni 的願景是不斷創新和開發技術，幫助人們從事重複性的日常工作，讓人們可以節省時間，完成機器無法替代的任務，也可以把多餘時間留給更多的自我實現。",
                "Nexuni，如同英文的字義，連結所有人。我們以人為本的信念是創新與成長的最大動力。歡迎所有懷有相同遠見與企圖心的人加入Nexuni，我們致力於打造一個舒適與激勵人的環境。"
            ],
            "ja": [
                "ソフトウェアインターンシップに参加して、最先端のロボット、インテリジェントストア、駐車場システムの開発に携わり、今日からインパクトを与えましょう。",
                "ハードウェアインターンシップに参加して、ロボットプラットフォームやIoTモジュールなどの設計に携わりましょう。実践的な機構設計スキルを学ぶ貴重な経験になります。",
                "Nexuni株式会社は、人々が反復作業を支援し、レストランの運営、駐車場の管理、施設管理などのサービスに対する労働の必要性を減らすための技術を開発することに専念してきました。良いソリューションは十分にテストされ、人々にアクセス可能であるべきです。",
                "Nexuniはみんなを一つにします。Nexuniの革新と成長を支えるのは人々です。同じビジョンと野心を持つすべての人をNexuniに歓迎します。私たちは、人々が快適に感じ、力を与えられるコミュニティを作ることを目指しています。"
            ]
        }
      }]
    },
    "career": {
      "web_content": [{
        "type": "slide_show",
        "action": [""],
        "title": {"en": ["Career"], "zh": ["開放職缺"], "ja": ["キャリア"]},
        "content": {"en": [""], "zh": [""], "ja": [""]},
        "img_num": "1",
        "arrow_flag": false,
        "logo_flag": true,
        "img": ["image/career_main.jpg"]
      },{
        "type": "word_section",
        "title": {
            "en": ["Join Nexuni"],
            "zh": ["加入Nexuni"],
            "ja": ["Nexuniに応募する"]
        },
        "content": {
            "en": [
                "Are you passionate about advanced automation technologies that solve labor problems? If the answer is yes, you might be the right fit for us. Nexuni develops automated solutions for labor-intensive industries and would like you to be a part of us. Please take a look at our list of opportunities below and contact us at hr@nexuni.com or check on <a href='https://www.104.com.tw/company/1a2x6bm4zo' style='color: #56b77e; text-decoration: underline;'>our 104 recruiting page</a>."
            ],
            "zh": [
                "你對最先進的AI自動化技術有熱忱嗎？Nexuni 的使命之一，是為勞力需求高的產業，提供最新的AI自動化產品，提升產業的管理效率及降低人力需求。我們也希望你能成為我們團隊的一份子，推廣劃時代的AI自動化產品。以下為常態性開放的職缺，有興趣請直接聯絡hr@nexuni.com。若要查看所有職缺，請點擊<a href='https://www.104.com.tw/company/1a2x6bm4zo' style='color: #56b77e; text-decoration: underline;'>此連結至104人力銀行頁面</a>。"
            ],
            "ja": [
                "先進的な自動化技術に情熱を持っていますか？ もし答えが「はい」なら、あなたは私たちにぴったりかもしれません。Nexuniは労働集約型産業向けの自動化ソリューションを開発しており、あなたもその一員になっていただきたいと考えています。以下のリストを確認し、hr@nexuni.comまでご連絡いただくか、<a href='https://www.104.com.tw/company/1a2x6bm4zo' style='color: #56b77e; text-decoration: underline;'>104の求人ページ</a>をご覧ください。"
            ]
        }
      },
      {
        "type": "list_section",
        "main_title": {"en": "Robot Software Engineer", "zh": "機器人軟體工程師", "ja": "ロボットソフトウェアエンジニア"},
        "action": () => this.navigate('/about/SE-robot'),
        "title": {
          "en": ["Location", "Requirement", "Description"],
          "zh": ["地點", "需求", "工作描述"],
          "ja": ["場所", "要件", "説明"]
        },
        "content": {
          "en": [
            ["Hsinchu, Taiwan"],
            ["Proficiency in C++, Python, Linux. Experience with ROS2, robotic software control, sensor integration (LiDAR, depth cameras, IMU), SLAM, and motion planning. Comfortable with git, docker and debug tools. Experience in computer vision, navigation, or edge computing (NVIDIA Jetson) is a plus."],
            ["Develop and integrate robotic software systems including perception, localization, path planning, and real-time control. Work with sensor fusion pipelines, ROS2 frameworks, and deploy on edge computing platforms for autonomous robot operation."]
          ],
          "zh": [
            ["新竹，台灣"],
            ["精通 C++, Python, Linux。具備 ROS2、機器人軟體控制、感測器整合（LiDAR、深度相機、IMU）、SLAM 與路徑規劃經驗。熟悉 git, docker 和調試工具。有電腦視覺、導航、或邊緣運算（NVIDIA Jetson）經驗者優先。"],
            ["開發與整合機器人軟體系統，包含感知、定位、路徑規劃與即時控制。負責感測器融合、ROS2 框架開發，並部署於邊緣運算平台以實現機器人自主運作。"]
          ],
          "ja": [
            ["台湾、新竹"],
            ["C++, Python, Linux に精通していること。ROS2、ロボットソフトウェア制御、センサー統合（LiDAR、深度カメラ、IMU）、SLAM、経路計画の経験。git, docker およびデバッグツールに慣れていること。コンピュータビジョン、ナビゲーション、エッジコンピューティング（NVIDIA Jetson）の経験があれば尚可。"],
            ["知覚、位置推定、経路計画、リアルタイム制御を含むロボットソフトウェアシステムの開発・統合。センサーフュージョン、ROS2 フレームワークの開発、エッジコンピューティングプラットフォームへの展開を担当。"]
          ]
        }
      },
      {
        "type": "list_section",
        "main_title": {"en": "AI Software Engineer", "zh": "AI軟體工程師", "ja": "AIソフトウェアエンジニア"},
        "action": () => this.navigate('/about/SE'),
        "title": {
          "en": ["Location", "Requirement", "Description"],
          "zh": ["地點", "需求", "工作描述"],
          "ja": ["場所", "要件", "説明"]
        },
        "content": {
          "en": [
            ["Hsinchu, Taiwan"],
            ["Proficiency in C++, Python, Linux. Experience in at least one deep learning framework: PyTorch/TensorFlow/Caffe. Comfortable with git, docker and debug tools. Experience in OpenCV, LLM, Reinforcement Learning, TinyML is a plus."],
            ["Develop AI automation software based on customer requirements. This includes integrating robots with various sensors, deploying AI models to edge computing platforms, optimizing recognition performance, and troubleshooting software systems."]
          ],
          "zh": [
            ["新竹，台灣"],
            ["精通 C++, Python, Linux。至少具備一種深度學習框架經驗：PyTorch/TensorFlow/Caffe。熟悉 git, docker 和調試工具。有 OpenCV、LLM、強化學習、TinyML 經驗者優先。"],
            ["根據客戶需求開發 AI 自動化軟體，包含整合各種感測器的機器人系統、將 AI 模型部署至邊緣運算平台、優化辨識效能與解決軟體系統問題。"]
          ],
          "ja": [
            ["台湾、新竹"],
            ["C++, Python, Linux に精通。PyTorch/TensorFlow/Caffe のいずれかの深層学習フレームワーク経験。git, docker およびデバッグツールに慣れていること。OpenCV、LLM、強化学習、TinyML の経験があれば尚可。"],
            ["顧客要求に基づき AI 自動化ソフトウェアを開発。センサー搭載ロボットの統合、AI モデルのエッジコンピューティング展開、認識性能の最適化、ソフトウェアシステムのトラブルシューティングを含む。"]
          ]
        }
      },
      {
        "type": "list_section",
        "main_title": {
            "en": "Sales/Business Development",
            "zh": "事業發展專員",
            "ja": "営業/事業開発"
        },
        "action": () => this.navigate('/about/SD'),
        "title": {
            "en": ["Location", "Requirement", "Description"],
            "zh": ["地點", "需求", "工作描述"],
            "ja": ["場所", "要件", "説明"]
        },
        "content": {
            "en": [
                ["Hsinchu, Taiwan"],
                ["Proficiency in communication and passionate with technology industry. Experience in business opportunities or joining tenders is a plus."],
                ["Discover business opportunities (ex: Smart Store, AI Machine and etc.) tenders, maintaining customer relationship."]
            ],
            "zh": [
                ["新竹，台灣"],
                ["溝通能力強，對科技行業充滿熱情。有商機發掘或投標經驗者優先。"],
                ["發掘商業機會（如AI軟體, 智慧工廠, 自動化應用等），維護客戶關係。"]
            ],
            "ja": [
                ["台湾、新竹"],
                ["コミュニケーション能力が高く、技術業界に情熱を持っていること。ビジネスチャンスの発見や入札の経験があるとなお良い。"],
                ["ビジネスチャンス（例：スマートストア、AI機械など）の発見、入札、顧客関係の維持。"]
            ]
        }
      },
      {
        "type": "list_section",
        "main_title": {"en": "Robot Hardware Design Engineer", "zh": "機器人硬體設計工程師", "ja": "ロボットハードウェア設計エンジニア"},
        "action": () => this.navigate('/about/HW-robot'),
        "title": {
          "en": ["Location", "Requirement", "Description"],
          "zh": ["地點", "需求", "工作描述"],
          "ja": ["場所", "要件", "説明"]
        },
        "content": {
          "en": [
            ["Hsinchu, Taiwan"],
            ["Proficiency in SolidWorks or AutoCAD. Experience in mechanism design, sheet metal fabrication, and prototyping. Familiar with 3D printing, CNC machining, and material selection. Understanding of actuators, sensors, and embedded hardware integration is a plus."],
            ["Design and develop mechanical structures and enclosures for AI robots and automation equipment. Collaborate with software and AI teams to integrate hardware with robotic platforms, IoT modules, and sensor systems."]
          ],
          "zh": [
            ["新竹，台灣"],
            ["精通 SolidWorks 或 AutoCAD。具機構設計、鈑金製造及原型開發經驗。熟悉 3D 列印、CNC 加工及材料選用。了解致動器、感測器及嵌入式硬體整合者優先。"],
            ["設計與開發 AI 機器人及自動化設備的機械結構與外殼。與軟體及 AI 團隊協作，整合硬體與機器人平台、IoT 模組及感測器系統。"]
          ],
          "ja": [
            ["台湾、新竹"],
            ["SolidWorksまたはAutoCADに精通していること。機構設計、板金加工、プロトタイピングの経験。3Dプリンティング、CNC加工、材料選定に精通。アクチュエータ、センサー、組み込みハードウェア統合の知識があれば尚可。"],
            ["AIロボットおよび自動化機器の機械構造と筐体を設計・開発。ソフトウェアおよびAIチームと協力し、ロボットプラットフォーム、IoTモジュール、センサーシステムとのハードウェア統合を行う。"]
          ]
        }
      },
      {
        "type": "list_section",
        "main_title": {"en": "Internship Program", "zh": "實習生計畫", "ja": ["インターンシッププログラム"]},
        "action": () => this.navigate('/about/intern'),
        "title": {
            "en": ["Summary"],
            "zh": ["簡介"],
            "ja": ["概要"]
        },
        "content": {
            "en": [
                ["Our interns are a part of Nexuni—involved and solving problems from the basics. We welcomed students with little to no experience to participate in our internship program. Currently, Nexuni provides two types of intern opportunities: software engineer intern and hardware engineer intern. The internship program usually takes place in the summer, but inquiries can be made for special circumstances. To receive our latest information for the internship program, please email contact@nexuni.com to request joining our mailing list or follow us on Instagram and Facebook for the latest news."]
            ],
            "zh": [
                ["你喜歡設計一些有趣的產品來解決人類生活中所遇到的問題嗎？我們重視科技上的創新，並透過多領域的結合，致力於透過自動化來解決人們生活中遇到的問題。因此，Nexuni特別注重每個成員解決問題的能力及想法，透過每周團隊聚會讓所有成員有機會發表及提出想法，同時也可學習如何跟多領域人才合作，一起完成專案。有別於其他實習計畫，Nexuni團隊更重視所有成員及實習生對工作的參與度及熱情，並尊重所有成員提出的每個好想法，熱烈歡迎勇於挑戰且想法創新的實習生。實習生是Nexuni很重要的一份子，完整地參與公司開發與營運的過程。我們目前提供兩種實習職位 –– 軟體工程實習與機器人硬體實習。除了特殊需求，耐思尼將在每年一月和七月開始進行為期半年的實習生計畫。若想收到實習資訊通知，歡迎來信訂閱電子報 contact@nexuni.com 或透過 Instagram, Facebook與我們聯絡。"]
            ],
            "ja": [
                ["Nexuniのインターンは、基礎から問題を解決するためにNexuniの一部となり、関わりを持ちます。経験の少ない学生も、インターンシッププログラムに参加することができます。現在、Nexuniでは2種類のインターンシップの機会を提供しています：ソフトウェアエンジニアインターンとハードウェアエンジニアインターンです。通常、インターンシッププログラムは夏に開催されますが、特別な事情がある場合は問い合わせが可能です。インターンシッププログラムに関する最新情報を受け取りたい場合は、contact@nexuni.comにメールしてメーリングリストへの登録を依頼するか、InstagramやFacebookで最新のニュースをフォローしてください。"]
            ]
        }
      }]

    },
    "softwareIntern": {
        "web_content": [{
            "type": "word_section",
            "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
            "content": {
              "en": ["We conduct a six-month internship program starting in January and July each year, with summer internships also available. The schedule for the internship program is flexible; please contact HR for the latest onboarding schedule.\n\n**Job Description**\n\n1. Develop software using Python or C++\n\n2. Assist with AI-related project development\n\n3. Weekly progress reports\n\n4. Additional Information\n\n    a. Working hours: At least two days per week, on-site\n\n    b. Location: 2nd Floor, No. 31 Huanke 1st Road, Changyi Technology Development Park, Zhubei City, Hsinchu County (Changyi Technology Park)\n\n    c. Compensation: Better than labor law standards, salary depends on hours worked\n\n**Requirements**\n\n1. Current university students or recent graduates, all majors considered (high school students considered under special circumstances)\n\n2. Proficient in Python or C++ programming syntax and logic\n\n3. Able to debug software and related issues\n\n4. Quick learner with a passion for new knowledge\n\n5. Good team player\n\n6. Familiar with git version control\n\n7. Experience developing in a Linux environment\n\n8. Some understanding of or passion for the AI field and data processing\n\n9. Ambitious and willing to challenge oneself\n\n**Preferred Qualifications**\n\n1. Familiar with Python mathematical computing and data manipulation tools (e.g., numpy, pandas, scipy)\n\n2. Understand image processing and related usage (e.g., OpenCV, MATLAB)\n\n3. Familiar with deep learning frameworks (e.g., PyTorch, TensorFlow)\n\n4. Experience in AI project development\n\n5. Experience with Docker\n\n**Selection Process**\n\n1. Please send the following materials to hr@nexuni.com with the subject line 'nexuni_Software_Engineer_Intern_YOURNAME'.\n\n    a. Resume in Chinese or English (required)\n\n    b. Information on past relevant projects (preferred)\n\n2. Zoom online interview\n\n    Interview includes: software development experience, reasons for joining the Nexuni intern program\n\n3. Notification by email\n\n    We will notify all candidates of the results of the Nexuni software development internship recruitment."],
              "zh": ["定期於每年一月和七月開始進行為期半年的實習生計畫，亦有提供暑期實習。實習計畫時程相較彈性，可聯絡HR以提供最近的onboard時程。\n\n\n\n【工作內容】\n\n1. 使用Python或 C++ 進行程式開發\n\n2. 協助AI相關專案開發\n\n3. 每週例會進度報告\n\n4. 其他相關資訊\n\n    a. 上班時間：每週配合至少兩天，需到辦公室\n\n    b. 上班地點：新竹縣竹北市昌益科技產發園區環科一路31號6樓之二（昌益科技園區）\n\n    c. 薪資待遇：優於勞基法，薪資與配合時數有關\n\n\n\n【徵求條件】\n\n1. 大學在校生或應屆畢業生，科系不拘（特殊狀況下可考慮高中生)\n\n2. 熟悉Python或C++的程式語法以及程式邏輯\n\n3. 有能力除錯程式及軟體環境相關問題\n\n4. 有快速學習新知的能力及熱忱\n\n5. 具備良好團隊合作精神\n\n6. 熟悉git版本控制\n\n7. 有在Linux環境上開發經驗\n\n8. 對AI領域及數據處理有一定了解或對這方面有熱忱\n\n9. 有上進心，願意挑戰自我\n\n\n\n【加分條件】\n\n1. 熟悉Python的數學計算與資料操作工具 (eg. numpy, pandas, scipy..)\n\n2. 了解影像處理及相關使用 (eg. opencv、matlab)\n\n3. 熟悉深度學習相關套件 (eg. pytorch、tensorflow)\n\n4. AI 專案開發經驗\n\n5. Docker使用經驗\n\n\n\n【徵選方法】\n\n1. 請將以下資料寄至 hr@nexuni.com 郵件標題為 nexuni_Software_Engineer_Intern_YOURNAME.\n\n    a. 中文或英文履歷(必要)\n\n    b. 過去相關專案資料(為佳)\n\n2. Zoom 線上面試\n\n    面試內容包含：軟體開發經驗、為何想加入Nexuni intern行列等\n\n3. 寄信通知結果\n\n    我們會通知所有來信的候選人Nexuni軟體開發實習生的招募結果。\n\n"],
              "ja": ["毎年1月と7月に開始される半年間のインターンシッププログラムを実施しています。また、夏期インターンシップも提供しています。インターンシップのスケジュールは柔軟で、最新のオンボーディングスケジュールについてはHRにお問い合わせください。\n\n**業務内容**\n\n1. PythonまたはC++を使用したソフトウェア開発\n\n2. AI関連プロジェクトの開発支援\n\n3. 週次進捗報告\n\n4. その他の関連情報\n\n    a. 勤務時間：週に少なくとも2日、オンサイト勤務\n\n    b. 勤務地：新竹県竹北市昌益科技産発園区環科一路31号6階の2（昌益科技園区）\n\n    c. 給与：労働基準法を上回る、時間に応じた給与\n\n**応募条件**\n\n1. 大学在学生または新卒者、専攻不問（特別な事情の下では高校生も検討）\n\n2. PythonまたはC++のプログラミング構文とロジックに精通していること\n\n3. プログラムおよびソフトウェア環境の問題をデバッグできること\n\n4. 新しい知識をすばやく学ぶ能力と情熱があること\n\n5. 優れたチームプレイヤーであること\n\n6. gitバージョン管理に精通していること\n\n7. Linux環境での開発経験があること\n\n8. AI分野およびデータ処理に関する一定の理解または情熱があること\n\n9. 上昇志向があり、自己挑戦を望む意欲があること\n\n**優遇される資格**\n\n1. Pythonの数学計算およびデータ操作ツール（例：numpy、pandas、scipy）に精通していること\n\n2. 画像処理および関連使用（例：OpenCV、MATLAB）を理解していること\n\n3. ディープラーニングフレームワーク（例：PyTorch、TensorFlow）に精通していること\n\n4. AIプロジェクト開発経験\n\n5. Dockerの使用経験\n\n**選考方法**\n\n1. 次の資料を 'nexuni_Software_Engineer_Intern_YOURNAME' という件名で hr@nexuni.com に送ってください。\n\n    a. 日本語または英語の履歴書（必須）\n\n    b. 過去の関連プロジェクトの情報（望ましい）\n\n2. Zoomでのオンライン面接\n\n    面接内容には、ソフトウェア開発の経験、Nexuniインターンプログラムへの参加理由などが含まれます\n\n3. 結果のメール通知\n\n    すべての応募者にNexuniソフトウェア開発インターンシップの採用結果を通知します。"]
            },
            "title": {
              "zh": ["軟體實習計畫"],
              "en": ["Nexuni Software Internship Program"],
              "ja": ["Nexuniソフトウェアインターンシッププログラム"]
            }
          },{
            "type": "word_btn",
            "action": () => this.navigate('/about/internSE2022Spring'),
            "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
            "content": {
              "en": ["Feb.22 – Jul.22"],
              "zh": ["Feb.22 – Jul.22"],
              "ja": ["Feb.22 – Jul.22"]},
            "title": {
              "en": ["Brian Wang — Software Intern Experience"],
              "zh": ["Brian Wang — 軟體實習心得"],
              "ja": ["Brian Wang — ソフトウェアインターン体験"]
            }},{
            "type": "word_btn",
            "action": () => this.navigate('/about/internSE2022Spring_wu'),
            "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
            "content": {
              "en": ["Feb.22 – Jul.22"],
              "zh": ["Feb.22 – Jul.22"],
              "ja": ["Feb.22 – Jul.22"]},
            "title": {
              "en": ["Xianglin Wu — Software Intern Experience"],
              "zh": ["Xianglin Wu — 軟體實習心得"],
              "ja": ["Xianglin Wu — ソフトウェアインターン体験"]
            }}],
    },
    "internSE2022Spring": {
        "web_content": [{
            "type": "pic_word_section",
            "style": {"text": {}, "img": {"scale": "70%"}},
            "title": {
              "en": "Brian Wang",
              "ja": "Brian Wang",
              "zh": "Brian Wang"},
            "content": {
              "en": "【臺大電資所碩士】 今年的 3 月到 6 月我在 Nexuni 的 robot team 實習，負責開發前後端跟深度學習模型的整合。雖然只在這裡短短幾個月，但學到很多在學校接觸不到的東西。\n\n在新創公司的一大好處是時間很自由，而且工作氣氛不會很壓抑，團隊人員也很樂於協助、教學。這裡的組成人員幾乎都跟我同齡，原本很擔心技術方面不夠成熟，但這幾個月看下來真的覺得大家很猛，框架、伺服器等等都是團隊自己寫一套，並非套用現成工具，而且持續有在改版更新。有些人甚至身兼數職，行政、管理、美術設計的東西也都是自己弄，真的很強！\n\n工作內容基本上就是每週訂定目標、開會回報。我被分配到的任務幾乎是從零開始的專案，相較於其他蠻多公司的實習內容都是偏打雜跟維護，這也是我覺得在這裡實習最大的收穫。\n\n最開始從前端開始開發，使用他們開發的開源 Web 框架 Famcy，除了要實現基本的前端功能也要跟 ROS (Robot Operating System) 串接；然後是後端的串接，使用 PostgreSQL 跟 Python 管理資料庫跟撰寫 API 。最後是跟深度學習相關的串接，大致上跟影像偵測相關的 Task。\n\n希望未來能看到 Nexuni 成為世界級的企業，認真覺得 Nexuni 的前途無量！",
              "ja": "【臺大電資所碩士】 今年的 3 月到 6 月我在 Nexuni 的 robot team 實習，負責開發前後端跟深度學習模型的整合。雖然只在這裡短短幾個月，但學到很多在學校接觸不到的東西。\n\n在新創公司的一大好處是時間很自由，而且工作氣氛不會很壓抑，團隊人員也很樂於協助、教學。這裡的組成人員幾乎都跟我同齡，原本很擔心技術方面不夠成熟，但這幾個月看下來真的覺得大家很猛，框架、伺服器等等都是團隊自己寫一套，並非套用現成工具，而且持續有在改版更新。有些人甚至身兼數職，行政、管理、美術設計的東西也都是自己弄，真的很強！\n\n工作內容基本上就是每週訂定目標、開會回報。我被分配到的任務幾乎是從零開始的專案，相較於其他蠻多公司的實習內容都是偏打雜跟維護，這也是我覺得在這裡實習最大的收穫。\n\n最開始從前端開始開發，使用他們開發的開源 Web 框架 Famcy，除了要實現基本的前端功能也要跟 ROS (Robot Operating System) 串接；然後是後端的串接，使用 PostgreSQL 跟 Python 管理資料庫跟撰寫 API 。最後是跟深度學習相關的串接，大致上跟影像偵測相關的 Task。\n\n希望未來能看到 Nexuni 成為世界級的企業，認真覺得 Nexuni 的前途無量！",
              "zh": "【臺大電資所碩士】 今年的 3 月到 6 月我在 Nexuni 的 robot team 實習，負責開發前後端跟深度學習模型的整合。雖然只在這裡短短幾個月，但學到很多在學校接觸不到的東西。\n\n在新創公司的一大好處是時間很自由，而且工作氣氛不會很壓抑，團隊人員也很樂於協助、教學。這裡的組成人員幾乎都跟我同齡，原本很擔心技術方面不夠成熟，但這幾個月看下來真的覺得大家很猛，框架、伺服器等等都是團隊自己寫一套，並非套用現成工具，而且持續有在改版更新。有些人甚至身兼數職，行政、管理、美術設計的東西也都是自己弄，真的很強！\n\n工作內容基本上就是每週訂定目標、開會回報。我被分配到的任務幾乎是從零開始的專案，相較於其他蠻多公司的實習內容都是偏打雜跟維護，這也是我覺得在這裡實習最大的收穫。\n\n最開始從前端開始開發，使用他們開發的開源 Web 框架 Famcy，除了要實現基本的前端功能也要跟 ROS (Robot Operating System) 串接；然後是後端的串接，使用 PostgreSQL 跟 Python 管理資料庫跟撰寫 API 。最後是跟深度學習相關的串接，大致上跟影像偵測相關的 Task。\n\n希望未來能看到 Nexuni 成為世界級的企業，認真覺得 Nexuni 的前途無量！"},
            "img": ["intern_wang.jpg"]
          }]
    },
    "internSE2022Spring_wu": {
        "web_content": [{
            "type": "pic_word_section",
            "style": {"text": {}, "img": {"scale": "70%"}},
            "title": {
              "en": "Xianglin Wu",
              "ja": "Xianglin Wu",
              "zh": "Xianglin Wu"},
            "content": {
              "en": "【政大國貿雙電物學程】 在實習期間，我扎扎實實的受到編寫前端的訓練，也在編寫當中，獲取了許多前後端的觀念。再者，對於 Python 的程式語感也更進一步，甚至也漸漸熟練 Python 物件導向方法的使用。另外，學習到postman、pdAdmin、docker的使用，也獲得許多寫程式的技巧以及提升團隊效率的方法。最重要的是，我能夠學到和團隊合作時，我應該怎麼陳述我的需求讓對方理解，也能有找到問題點並解決之的經驗，甚至是正式Demo的各個細節的注意。我想我在Nexuni的所學，是真的相當受用的！\n\n而在實習期間，遭逢挑戰是不可避免的。我剛開始只會 Python 的基礎語法，面對排山倒海的資訊以及編寫方法與技巧，有些會有學習順序，先備知識不足會影響後續進行。像是若要熟悉Famcy的使用方法，就得先理解物件導向的運作。那個時期說實在我差點就被壓垮了。幸好 Nexuni 的所有人都非常的有熱心，很願意教我各個觀念與細節，並且不厭其煩的再三為我重複，我才得以在這麼短的時間內能夠快速的進入狀況。此外，一開始我也不太能順利的問好問題，對於前後端的運作流程也不甚了解。這就導致我在陳述問題時，會說的不夠精準，要花很大力氣解釋。但後來在主管不斷的給予回饋下，我逐漸能夠把我的問題敘述清楚了，這對於團隊溝通而言，是相當重要的一件事情。\n\n  而對於 Nexuni ，我認為在這裡的氣氛是相當融洽的，每個人都很願意互相幫助，並且快速的解決問題。另外，也很願意給實習生嘗試的機會，只要實習生願意做，Nexuni都會給予很大的空間發揮。此外，Nexuni 也常常會教導實習生很多的開發知識，以及過往經驗，不會有所保留。我想在這裡，覺得能夠帶走許多珍貴的知識與經驗寶藏！",
              "ja": "【政大國貿雙電物學程】 在實習期間，我扎扎實實的受到編寫前端的訓練，也在編寫當中，獲取了許多前後端的觀念。再者，對於 Python 的程式語感也更進一步，甚至也漸漸熟練 Python 物件導向方法的使用。另外，學習到postman、pdAdmin、docker的使用，也獲得許多寫程式的技巧以及提升團隊效率的方法。最重要的是，我能夠學到和團隊合作時，我應該怎麼陳述我的需求讓對方理解，也能有找到問題點並解決之的經驗，甚至是正式Demo的各個細節的注意。我想我在Nexuni的所學，是真的相當受用的！",
              "zh": "【政大國貿雙電物學程】 在實習期間，我扎扎實實的受到編寫前端的訓練，也在編寫當中，獲取了許多前後端的觀念。再者，對於 Python 的程式語感也更進一步，甚至也漸漸熟練 Python 物件導向方法的使用。另外，學習到postman、pdAdmin、docker的使用，也獲得許多寫程式的技巧以及提升團隊效率的方法。最重要的是，我能夠學到和團隊合作時，我應該怎麼陳述我的需求讓對方理解，也能有找到問題點並解決之的經驗，甚至是正式Demo的各個細節的注意。我想我在Nexuni的所學，是真的相當受用的！"},
            "img": ["intern_wu.jpg"]
          }]
    },
    "hardwareIntern": {
      "web_content":[{
            "type": "word_section",
            "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
            "content": {
              "en": ["We regularly start a six-month internship program every January and July, with summer internships also available. The internship schedule is flexible; please contact HR for the most recent onboarding schedule.\n\n**Job Description**\n\n1. Create CAD and 3D files\n\n2. Assist with production scheduling and engineering drawing modifications\n\n3. Involved in mechanism design and function conceptualization\n\n4. Participate in the development of hardware such as AIoT module mechanism design, smart robot control platforms, smart living control modules, etc.\n\n5. Weekly progress report meetings\n\n6. Additional Information\n\n    a. Working hours: At least two days per week, on-site\n\n    b. Location: 2nd Floor, No. 31 Huanke 1st Road, Changyi Technology Development Park, Zhubei City, Hsinchu County (Changyi Technology Park)\n\n    c. Compensation: Above labor law standards, salary depends on hours worked\n\n**Requirements**\n\n1. Current university students or recent graduates, all majors considered (high school students considered under special circumstances)\n\n2. Proficient with drafting software such as AutoCAD or SolidWorks\n\n3. Capable of modifying AutoCAD or SolidWorks as per requirements\n\n4. Quick to learn new knowledge and passionate\n\n5. Good team player\n\n**Additional Qualifications**\n\n1. Practical experience with CNC machining\n\n2. Practical experience with laser cutting\n\n3. Practical experience with acrylic processing\n\n**Selection Process**\n\n1. Please send the following materials to hr@nexuni.com with the subject line 'nexuni_Hardware_Engineer_Intern_YOURNAME'.\n\n    a. Resume in Chinese or English (required)\n\n    b. Past AutoCAD or SolidWorks drawings (required)\n\n2. Zoom online interview\n\n    Interview includes: hardware design and development experience, reasons for joining the Nexuni intern program\n\n3. Notification by email\n\n    We will notify all candidates of the results of the Nexuni hardware design and development internship recruitment."],
              "ja": ["毎年1月と7月に開始する半年間のインターンシッププログラムを定期的に実施しており、夏季インターンシップも提供しています。インターンシップのスケジュールは柔軟ですので、最新のオンボーディングスケジュールについてはHRにお問い合わせください。\n\n**職務内容**\n\n1. CADおよび3Dファイルの作成\n\n2. 生産スケジューリングとエンジニアリング図面の修正を支援\n\n3. 機構設計と機能概念化に関与\n\n4. AIoTモジュールの機構設計、スマートロボット制御プラットフォーム、スマートリビング制御モジュールなどのハードウェア開発に参加\n\n5. 週次の進捗報告会\n\n6. その他の情報\n\n    a. 勤務時間：週に少なくとも2日、オンサイト勤務\n\n    b. 勤務地：新竹県竹北市昌益科技産発園区環科一路31号6階の2（昌益科技園区）\n\n    c. 給与：労働基準法を超える、時間に応じた給与\n\n**応募資格**\n\n1. 大学生または最近卒業した学生、専攻不問（特別な事情がある場合は高校生も検討）\n\n2. AutoCADやSolidWorksなどの製図ソフトウェアに精通していること\n\n3. 要件に応じてAutoCADやSolidWorksを修正できる能力\n\n4. 新しい知識をすばやく学ぶ情熱があること\n\n5. 優れたチームプレイヤーであること\n\n**優遇される資格**\n\n1. CNC加工の実務経験\n\n2. レーザーカット加工の実務経験\n\n3. アクリル加工の実務経験\n\n**選考プロセス**\n\n1. 'nexuni_Hardware_Engineer_Intern_YOURNAME'という件名で hr@nexuni.com に以下の資料を送付してください。\n\n    a. 日本語または英語の履歴書（必須）\n\n    b. 過去のAutoCADまたはSolidWorksの図面（必須）\n\n2. Zoomでのオンライン面接\n\n    面接内容には、ハードウェア設計及び開発の経験、Nexuniインターンプログラムへの参加理由などが含まれます\n\n3. メールでの通知\n\n    すべての候補者にNexuniハードウェア設計開発インターンシップの採用結果を通知します。"],
            "zh": ["定期於每年一月和七月開始進行為期半年的實習生計畫，亦有提供暑期實習。實習計畫時程相較彈性，可聯絡HR以提供最近的onboard時程。\n\n\n\n【工作內容】\n\n1. 畫製CAD及3D圖檔\n\n2. 協助生產排程及工程圖修改\n\n3. 相關機構設計及功能發想\n\n4. 參與開發的硬體如：AIoT模組機構設計、智慧機器人控制平台、智慧生活控制模組等\n\n5. 每週例會進度報告\n\n6. 其他相關資訊\n\n    a. 上班時間：每週配合至少兩天，需到辦公室\n\n    b. 上班地點：新竹縣竹北市昌益科技產發園區環科一路31號6樓之二（昌益科技園區）\n\n    c. 薪資待遇：優於勞基法，薪資與配合時數有關\n\n\n\n【徵求條件】\n\n1. 大學在校生或應屆畢業生，科系不拘（特殊狀況下可考慮高中生）\n\n2. 熟悉AutoCAD 或 solidworks等製圖軟體\n\n3. 有能力依需求修改AutoCAD或solidworks\n\n4. 有快速學習新知的能力及熱忱\n\n5. 具備良好團隊合作精神\n\n\n\n【加分條件】\n\n1. cnc機械加工實際經驗\n\n2. 雷射切割加工實際經驗\n\n3. 壓克力加工實際經驗\n\n\n\n【徵選方法】\n\n1. 請將以下資料寄至 hr@nexuni.com 郵件標題為 nexuni_Hardware_Engineer_Intern_YOURNAME.\n\n    a. 中文或英文履歷(必要)\n\n    b. 過去畫製AutoCAD或solidworks圖(必要)\n\n2. Zoom 線上面試\n\n面試內容包含：硬體設計及開發經驗、為何想加入Nexuni intern行列等\n\n3. 寄信通知結果\n\n我們會通知所有來信的候選人Nexuni硬體設計開發實習生的招募結果。\n\n"]},
            "title": {
              "en": ["Nexuni Hardware Internship Program"],
              "zh": ["硬體實習計畫"],
              "ja": ["Nexuniハードウェアインターンシッププログラム"]
            }
          },{
            "type": "word_btn",
            "action": () => this.navigate('/about/internME2022Spring'),
            "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
            "content": {
              "en": ["Feb.22 – Jul.22"],
              "zh": ["Feb.22 – Jul.22"],
              "ja": ["Feb.22 – Jul.22"]
            },
            "title": {
              "en": ["2022 SP Hardware Internship Program Experience"],
              "zh": ["2022 SP硬體實習生計畫心得"],
              "ja": ["2022 SPハードウェアインターンシッププログラム体験"]
            }}]
    },
    "internME2022Spring": {
        "web_content": [{
            "type": "pic_word_section",
            "style": {"text": {}, "img": {"scale": "70%"}},
            "title": {
              "en": "YuHsuan Hsu",
              "zh": "YuHsuan Hsu",
              "ja": "YuHsuan Hsu"},
            "content": {
              "en": "【台大機械系】 在實習的這段時間，我參與了幾個專案，包括: 自動巡邏車、智慧廁所、Doday Bar自動飲料機。整體來說，實習的體驗非常良好，循序漸進的帶領，緊湊的進度安排，以及實作的設計體驗。\n\n最一開始我從對硬體設計的還懵懵懂懂的情況下進入了Nexuni，當時我對硬體的設計流程還不是非常了解，總覺得把3D圖畫出來送到工廠就可以製做了；但其實這過程中藏有很多細節，例如板金的製作成型，或者是成本考量。過程中有總總因素需要考慮，也因為加入了這些細節的部分，能讓我設計出的物品更接近真正實用的產品。\n\n雖然Nexuni人不多，但裡面的氛圍非常融洽，在這裡不僅僅可以學到硬體的設計以及實作，也能參與會議交流互相分享想法。每次的會議都很有效率，分享每周的進度，同時也檢討設計上的問題，並且訂下每周的目標。因此，這幾個月下來，我覺得在Nexuni實習對我來說學習到非常多東西，也很推薦其他有興趣的人來實習。",
              "ja": "【台大機械系】 在實習的這段時間，我參與了幾個專案，包括: 自動巡邏車、智慧廁所、Doday Bar自動飲料機。整體來說，實習的體驗非常良好，循序漸進的帶領，緊湊的進度安排，以及實作的設計體驗。",
              "zh": "【台大機械系】 在實習的這段時間，我參與了幾個專案，包括: 自動巡邏車、智慧廁所、Doday Bar自動飲料機。整體來說，實習的體驗非常良好，循序漸進的帶領，緊湊的進度安排，以及實作的設計體驗。\n\n最一開始我從對硬體設計的還懵懵懂懂的情況下進入了Nexuni，當時我對硬體的設計流程還不是非常了解，總覺得把3D圖畫出來送到工廠就可以製做了；但其實這過程中藏有很多細節，例如板金的製作成型，或者是成本考量。過程中有總總因素需要考慮，也因為加入了這些細節的部分，能讓我設計出的物品更接近真正實用的產品。\n\n雖然Nexuni人不多，但裡面的氛圍非常融洽，在這裡不僅僅可以學到硬體的設計以及實作，也能參與會議交流互相分享想法。每次的會議都很有效率，分享每周的進度，同時也檢討設計上的問題，並且訂下每周的目標。因此，這幾個月下來，我覺得在Nexuni實習對我來說學習到非常多東西，也很推薦其他有興趣的人來實習。"},
            "img": ["intern_hsu.jpg"]
          }]
    },
    "SE-robot": {
      "web_content": [{
        "type": "slide_show",
        "action": [""],
        "title": {"en": ["Robot Software Engineer"], "zh": ["機器人軟體工程師"], "ja": ["ロボットソフトウェアエンジニア"]},
        "content": {"en": [""], "zh": [""], "ja": [""]},
        "img_num": "1",
        "arrow_flag": false,
        "logo_flag": true,
        "img": ["image/career_main.jpg"]
      },{
        "type": "word_section",
        "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
        "title": {
          "en": ["Job Content"],
          "zh": ["工作內容"],
          "ja": ["仕事内容"]
        },
        "content": {
            "zh": [
              "▎ 工作地點 : 新竹縣竹北市\n\n▎ 職務說明\n\n1. 開發與維護機器人軟體系統，包含感知、定位（SLAM）、路徑規劃與即時運動控制\n\n2. 基於 ROS2 框架進行機器人系統架構設計與模組開發\n\n3. 整合多種感測器（LiDAR、深度相機、IMU、編碼器等）並開發感測器融合演算法\n\n4. 開發與調校導航、避障與路徑規劃模組\n\n5. 將機器人軟體部署至邊緣運算平台（如 NVIDIA Jetson）\n\n6. 與硬體及 AI 團隊協作，進行系統整合與現場測試\n\n▎ 技能需求\n\n1. 精通 C++ 與 Python，熟悉 Linux 開發環境\n\n2. 具備 ROS2 開發經驗，熟悉 ROS2 節點、Topic、Service、Action 等通訊機制\n\n3. 具備 SLAM（如 Cartographer、RTAB-Map、ORB-SLAM）或視覺/光達定位經驗\n\n4. 熟悉機器人運動學、路徑規劃演算法（如 Nav2、A*、RRT）\n\n5. 了解感測器原理與資料處理（LiDAR 點雲、深度影像、IMU 融合）\n\n6. 熟悉 git 版本控制，具備除錯與系統排障能力\n\n7. 具備良好團隊合作精神與溝通能力\n\n▎ 具備以下條件尤佳（加分條件）\n\n1. 參加過 Nexuni 軟體開發實習生計畫\n\n2. 具有自主移動機器人（AMR）或協作機器手臂軟體開發經驗\n\n3. 具有 NVIDIA Jetson 平台開發經驗\n\n4. 具有 Gazebo/Isaac Sim 等機器人模擬環境使用經驗\n\n5. 具有即時系統或嵌入式系統開發經驗\n\n6. Docker 使用經驗\n\n▎ 工作待遇\n\n待遇面議\n\n▎ 工作性質\n\n全職\n\n▎ 上班地點\n\n新竹縣竹北市環科一路31號6樓之二"
            ],
            "en": [
              "▎ Work Location: Zhubei City, Hsinchu County\n\n▎ Job Description\n\n1. Develop and maintain robotic software systems including perception, localization (SLAM), path planning, and real-time motion control\n\n2. Design robot system architecture and develop modules based on the ROS2 framework\n\n3. Integrate multiple sensors (LiDAR, depth cameras, IMU, encoders, etc.) and develop sensor fusion algorithms\n\n4. Develop and tune navigation, obstacle avoidance, and path planning modules\n\n5. Deploy robotic software on edge computing platforms (e.g., NVIDIA Jetson)\n\n6. Collaborate with hardware and AI teams for system integration and field testing\n\n▎ Skill Requirements\n\n1. Proficient in C++ and Python with Linux development experience\n\n2. Experience with ROS2 development, including nodes, topics, services, and actions\n\n3. Experience with SLAM (e.g., Cartographer, RTAB-Map, ORB-SLAM) or visual/LiDAR-based localization\n\n4. Familiarity with robot kinematics and path planning algorithms (e.g., Nav2, A*, RRT)\n\n5. Understanding of sensor principles and data processing (LiDAR point clouds, depth images, IMU fusion)\n\n6. Familiar with git version control, debugging, and system troubleshooting\n\n7. Strong teamwork and communication skills\n\n▎ Preferred Qualifications (Bonus Conditions)\n\n1. Participation in the Nexuni software development internship program\n\n2. Experience developing software for autonomous mobile robots (AMR) or collaborative robot arms\n\n3. Experience with NVIDIA Jetson platform development\n\n4. Experience with robot simulation environments (Gazebo, Isaac Sim)\n\n5. Experience with real-time systems or embedded systems development\n\n6. Experience using Docker\n\n▎ Salary\n\nSalary is negotiable\n\n▎ Job Nature\n\nFull-time\n\n▎ Work Location\n\n6th Floor, No. 2, No. 31, HuanKe Yi Road, Zhubei City, Hsinchu County"
            ],
            "ja": [
              "▎ 勤務地: 新竹県竹北市\n\n▎ 職務内容\n\n1. 知覚、位置推定（SLAM）、経路計画、リアルタイム運動制御を含むロボットソフトウェアシステムの開発・保守\n\n2. ROS2 フレームワークに基づくロボットシステムアーキテクチャの設計とモジュール開発\n\n3. 複数のセンサー（LiDAR、深度カメラ、IMU、エンコーダ等）の統合およびセンサーフュージョンアルゴリズムの開発\n\n4. ナビゲーション、障害物回避、経路計画モジュールの開発とチューニング\n\n5. ロボットソフトウェアをエッジコンピューティングプラットフォーム（NVIDIA Jetson 等）に展開\n\n6. ハードウェアおよび AI チームと協力し、システム統合と現場テストを実施\n\n▎ スキル要件\n\n1. C++ と Python に精通し、Linux 開発環境での経験があること\n\n2. ROS2 の開発経験（ノード、トピック、サービス、アクション等の通信メカニズム）\n\n3. SLAM（Cartographer、RTAB-Map、ORB-SLAM 等）またはビジョン/LiDAR ベースの位置推定経験\n\n4. ロボット運動学および経路計画アルゴリズム（Nav2、A*、RRT 等）に精通\n\n5. センサーの原理とデータ処理（LiDAR 点群、深度画像、IMU フュージョン）の理解\n\n6. git バージョン管理、デバッグ、システムトラブルシューティングに精通\n\n7. 優れたチームワークとコミュニケーション能力\n\n▎ 以下の条件を満たす方は優遇（加点条件）\n\n1. Nexuni ソフトウェア開発インターンシッププログラムに参加経験\n\n2. 自律移動ロボット（AMR）または協働ロボットアームのソフトウェア開発経験\n\n3. NVIDIA Jetson プラットフォームでの開発経験\n\n4. ロボットシミュレーション環境（Gazebo、Isaac Sim）の使用経験\n\n5. リアルタイムシステムまたは組み込みシステムの開発経験\n\n6. Docker の使用経験\n\n▎ 給与\n\n給与は面談の上決定\n\n▎ 雇用形態\n\nフルタイム\n\n▎ 勤務地\n\n新竹県竹北市環科一路31号6階之二"
            ]
          }
    }]},
    "SE": {
      "web_content": [{
        "type": "slide_show",
        "action": [""],
        "title": {"en": ["AI Software Engineer"], "zh": ["AI軟體工程師"], "ja": ["AIソフトウェアエンジニア"]},
        "content": {"en": [""], "zh": [""], "ja": [""]},
        "img_num": "1",
        "arrow_flag": false,
        "logo_flag": true,
        "img": ["image/career_main.jpg"]
      },{
        "type": "word_section",
        "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
        "title": {
            "en": ["Job Content"],
            "zh": ["工作內容"],
            "ja": ["仕事内容"]
        },
        "content": {
            "zh": [
              "▎ 工作地點 : 新竹縣竹北市\n\n▎ 職務說明\n\n1. 負責 AI 相關專案的技術研發\n\n2. 搭配機器學習並設計及開發演算法來達成專案目標\n\n3. Deploy AI 到邊緣化運算平台\n\n4. 負責影像串流及處理\n\n5. 優化 AI 程式性能及辨識速度\n\n6. 配合 MLOps 框架\n\n▎ 技能需求\n\n1. 熟悉 Python 或 C++ 的程式語法以及程式邏輯\n\n2. 熟悉 AI Machine Learning 框架 (PyTorch/Tensorflow)\n\n3. 熟悉影像處理相關 library 如 OpenCV, numpy 等\n\n4. 有能力除錯程式及軟體環境相關問題\n\n5. 有快速學習新知的能力及熱忱\n\n6. 具備良好團隊合作精神\n\n7. 熟悉 git 版本控制\n\n8. 有在 Linux 環境上開發經驗\n\n9. 對 AI 領域及數據處理有一定了解或對這方面有熱忱\n\n▎ 具備以下條件尤佳（加分條件）\n\n1. 參加過 Nexuni 軟體開發實習生計畫\n\n2. 具有電腦視覺專案開發經驗\n\n3. 具有 NVIDIA Jetson 平台開發經驗\n\n4. 有設計 AI 神經網路模型相關經驗並了解各參數以及模型的設計 tradeoff\n\n5. 有 LLM、強化學習、TinyML 相關經驗\n\n6. Docker 使用經驗\n\n▎ 工作待遇\n\n待遇面議\n\n▎ 工作性質\n\n全職\n\n▎ 上班地點\n\n新竹縣竹北市環科一路31號6樓之二"
            ],
            "en": [
              "▎ Work Location: Zhubei City, Hsinchu County\n\n▎ Job Description\n\n1. Responsible for technical research and development of AI-related projects\n\n2. Design and develop algorithms with machine learning to achieve project goals\n\n3. Deploy AI to edge computing platforms\n\n4. Responsible for video streaming and processing\n\n5. Optimize AI program performance and recognition speed\n\n6. Collaborate with the MLOps framework\n\n▎ Skill Requirements\n\n1. Proficient in Python or C++ programming syntax and logic\n\n2. Familiar with AI Machine Learning frameworks (PyTorch/TensorFlow)\n\n3. Familiar with image processing libraries such as OpenCV, numpy, etc.\n\n4. Ability to debug program and software environment issues\n\n5. Ability and enthusiasm for quickly learning new knowledge\n\n6. Good team spirit\n\n7. Familiar with git version control\n\n8. Experience in development in Linux environments\n\n9. Understanding of or passion for AI and data processing\n\n▎ Preferred Qualifications (Bonus Conditions)\n\n1. Participation in the Nexuni software development internship program\n\n2. Experience in computer vision project development\n\n3. Experience in development on the NVIDIA Jetson platform\n\n4. Experience in designing AI neural network models and understanding the trade-offs in model parameter design\n\n5. Experience with LLM, Reinforcement Learning, or TinyML\n\n6. Experience using Docker\n\n▎ Salary\n\nSalary is negotiable\n\n▎ Job Nature\n\nFull-time\n\n▎ Work Location\n\n6th Floor, No. 2, No. 31, HuanKe Yi Road, Zhubei City, Hsinchu County"
            ],
            "ja": [
              "▎ 勤務地: 新竹県竹北市\n\n▎ 職務内容\n\n1. AI 関連プロジェクトの技術研究開発を担当\n\n2. 機械学習を用いてアルゴリズムを設計・開発し、プロジェクト目標を達成\n\n3. AI をエッジコンピューティングプラットフォームに展開\n\n4. 映像ストリーミングと処理を担当\n\n5. AI プログラムの性能と認識速度を最適化\n\n6. MLOps フレームワークに対応\n\n▎ スキル要件\n\n1. Python または C++ のプログラミング構文と論理に精通\n\n2. AI 機械学習フレームワーク（PyTorch/TensorFlow）に精通\n\n3. OpenCV、numpy などの画像処理ライブラリに精通\n\n4. プログラムおよびソフトウェア環境の問題をデバッグする能力\n\n5. 新しい知識を迅速に学ぶ能力と情熱\n\n6. 良好なチームワーク精神\n\n7. git バージョン管理に精通\n\n8. Linux 環境での開発経験\n\n9. AI 分野およびデータ処理に対する理解または熱意\n\n▎ 以下の条件を満たす方は優遇（加点条件）\n\n1. Nexuni ソフトウェア開発インターンシッププログラムに参加経験\n\n2. コンピュータビジョンプロジェクト開発の経験\n\n3. NVIDIA Jetson プラットフォームでの開発経験\n\n4. AI ニューラルネットワークモデルの設計経験があり、パラメータおよびモデル設計のトレードオフを理解\n\n5. LLM、強化学習、TinyML の経験\n\n6. Docker の使用経験\n\n▎ 給与\n\n給与は面談の上決定\n\n▎ 雇用形態\n\nフルタイム\n\n▎ 勤務地\n\n新竹県竹北市環科一路31号6階之二"
            ]
        }
      }]
    },
    "SD": {
      "web_content": [{
        "type": "slide_show",
        "action": [""],
        "title": {"en": ["Sales/Business Development"], "zh": ["事業發展專員"], "ja": ["営業/事業開発"]},
        "content": {"en": [""], "zh": [""], "ja": [""]},
        "img_num": "1",
        "arrow_flag": false,
        "logo_flag": true,
        "img": ["image/career_main.jpg"]
      },{
        "type": "word_section",
        "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
        "title": {
            "en": ["Job Description"],
            "zh": ["工作內容"],
            "ja": ["仕事内容"]
        },
        "content": {
            "en": ["▎ Work Location: Zhubei City, Hsinchu County\n\n▎ Job Content:\n\n- Discover business opportunities (Smart Store, AI Machine, etc.) and tenders\n\n- Maintain customer relationships\n\n- Proficiency in communication and passionate about the technology industry\n\n- Experience in business opportunities or joining tenders is a plus\n\n▎ Salary\n\nSalary is negotiable\n\n▎ Job Nature\n\nFull-time\n\n▎ Work Location\n\n6th Floor, No. 31-2, Huan Ke 1st Road, Zhubei City, Hsinchu County"],
            "zh": ["▎ 工作地點: 新竹縣竹北市\n\n▎ 職務內容:\n\n- 發掘商業機會（如AI軟體, 智慧工廠, 自動化應用等），維護客戶關係\n\n- 溝通能力強，對科技行業充滿熱情\n\n- 有商機發掘或投標經驗者優先\n\n▎ 工作待遇\n\n待遇面議\n\n▎ 工作性質\n\n全職\n\n▎ 上班地點\n\n新竹縣竹北市環科一路31號6樓之二"],
            "ja": ["▎ 勤務地: 新竹県竹北市\n\n▎ 職務内容:\n\n- ビジネスチャンス（スマートストア、AI機械など）の発見、入札\n\n- 顧客関係の維持\n\n- コミュニケーション能力が高く、技術業界に情熱を持っていること\n\n- ビジネスチャンスの発見や入札の経験があるとなお良い\n\n▎ 給与\n\n給与は面談の上決定\n\n▎ 雇用形態\n\nフルタイム\n\n▎ 勤務地\n\n新竹県竹北市環科一路31号6階之二"]
        }
      }]
    },
    "HW-robot": {
      "web_content": [{
        "type": "slide_show",
        "action": [""],
        "title": {"en": ["Robot Hardware Design Engineer"], "zh": ["機器人硬體設計工程師"], "ja": ["ロボットハードウェア設計エンジニア"]},
        "content": {"en": [""], "zh": [""], "ja": [""]},
        "img_num": "1",
        "arrow_flag": false,
        "logo_flag": true,
        "img": ["image/career_main.jpg"]
      },{
        "type": "word_section",
        "style": {"div": {width: '100%'}, "h3": {}, "h4": {}},
        "title": {
          "en": ["Job Content"],
          "zh": ["工作內容"],
          "ja": ["仕事内容"]
        },
        "content": {
            "zh": [
              "▎ 工作地點 : 新竹縣竹北市\n\n▎ 職務說明\n\n1. 設計與開發 AI 機器人及自動化設備之機械結構與外殼\n\n2. 繪製 CAD 及 3D 圖檔，並產出工程圖面\n\n3. 負責機構零件選料、公差分析及原型製作\n\n4. 與軟體及 AI 團隊協作，整合感測器、致動器及嵌入式硬體\n\n5. 評估並導入鈑金、CNC、3D 列印等製程\n\n6. 參與產品測試、組裝及品質改善\n\n7. 撰寫 BOM 表及組裝 SOP 文件\n\n▎ 技能需求\n\n1. 精通 SolidWorks 或 AutoCAD 等 3D 機構設計軟體\n\n2. 熟悉機械機構設計原理（齒輪、連桿、傳動等）\n\n3. 具鈑金設計及加工製程知識\n\n4. 有能力獨立進行公差分析與結構強度評估\n\n5. 具備良好團隊合作及跨部門溝通能力\n\n6. 有快速學習新知的能力及熱忱\n\n▎ 具備以下條件尤佳（加分條件）\n\n1. 參加過 Nexuni 硬體設計開發實習生計畫\n\n2. 具有機器人或自動化設備之機構設計經驗\n\n3. 具有 CNC 加工及雷射切割實作經驗\n\n4. 熟悉致動器（馬達、氣壓缸等）及感測器整合\n\n5. 具有 IoT 硬體模組開發經驗\n\n6. 了解嵌入式系統基礎（如 Arduino、Raspberry Pi）\n\n▎ 工作待遇\n\n待遇面議\n\n▎ 工作性質\n\n全職\n\n▎ 上班地點\n\n新竹縣竹北市環科一路31號6樓之二"
            ],
            "en": [
              "▎ Work Location: Zhubei City, Hsinchu County\n\n▎ Job Description\n\n1. Design and develop mechanical structures and enclosures for AI robots and automation equipment\n\n2. Create CAD and 3D model files and produce engineering drawings\n\n3. Responsible for component material selection, tolerance analysis, and prototyping\n\n4. Collaborate with software and AI teams to integrate sensors, actuators, and embedded hardware\n\n5. Evaluate and implement manufacturing processes including sheet metal, CNC machining, and 3D printing\n\n6. Participate in product testing, assembly, and quality improvement\n\n7. Prepare BOM lists and assembly SOP documentation\n\n▎ Skill Requirements\n\n1. Proficient in SolidWorks or AutoCAD 3D mechanical design software\n\n2. Familiar with mechanical design principles (gears, linkages, transmission systems, etc.)\n\n3. Knowledge of sheet metal design and fabrication processes\n\n4. Ability to independently perform tolerance analysis and structural strength evaluation\n\n5. Good teamwork and cross-departmental communication skills\n\n6. Ability and enthusiasm for quickly learning new knowledge\n\n▎ Preferred Qualifications (Bonus Conditions)\n\n1. Participation in the Nexuni hardware design internship program\n\n2. Experience in mechanism design for robots or automation equipment\n\n3. Hands-on experience with CNC machining and laser cutting\n\n4. Familiar with actuator (motors, pneumatic cylinders, etc.) and sensor integration\n\n5. Experience in IoT hardware module development\n\n6. Understanding of embedded systems basics (e.g., Arduino, Raspberry Pi)\n\n▎ Salary\n\nSalary is negotiable\n\n▎ Job Nature\n\nFull-time\n\n▎ Work Location\n\n6th Floor, No. 2, No. 31, HuanKe Yi Road, Zhubei City, Hsinchu County"
            ],
            "ja": [
              "▎ 勤務地: 新竹県竹北市\n\n▎ 職務内容\n\n1. AIロボットおよび自動化機器の機械構造と筐体を設計・開発\n\n2. CADおよび3Dモデルファイルの作成、エンジニアリング図面の出力\n\n3. 部品の材料選定、公差解析、およびプロトタイプ製作を担当\n\n4. ソフトウェアおよびAIチームと協力し、センサー、アクチュエータ、組み込みハードウェアの統合\n\n5. 板金加工、CNC加工、3Dプリンティングなどの製造プロセスの評価と導入\n\n6. 製品テスト、組み立て、品質改善に参加\n\n7. BOMリストおよび組み立てSOPドキュメントの作成\n\n▎ スキル要件\n\n1. SolidWorksまたはAutoCADなどの3D機械設計ソフトウェアに精通\n\n2. 機械設計の原理（ギア、リンク機構、伝動システムなど）に精通\n\n3. 板金設計および加工プロセスの知識\n\n4. 公差解析および構造強度評価を独立して行う能力\n\n5. 優れたチームワークおよび部門間コミュニケーション能力\n\n6. 新しい知識を迅速に学ぶ能力と情熱\n\n▎ 優遇条件（加点条件）\n\n1. Nexuniハードウェア設計インターンシッププログラムに参加経験\n\n2. ロボットまたは自動化機器の機構設計経験\n\n3. CNC加工およびレーザーカットの実務経験\n\n4. アクチュエータ（モーター、空圧シリンダーなど）およびセンサー統合の知識\n\n5. IoTハードウェアモジュールの開発経験\n\n6. 組み込みシステムの基礎（Arduino、Raspberry Piなど）の理解\n\n▎ 給与\n\n給与は面談の上決定\n\n▎ 雇用形態\n\nフルタイム\n\n▎ 勤務地\n\n新竹県竹北市環科一路31号6階之二"
            ]
          }
    }]},
    "news": {
      "web_content": [{
        "type": "news_item",
        "content": [{
          "title": "輝達GTC揭台灣供應鏈完整名單 - nexuni",
          "desc": "黃仁勳於GTC公布台灣供應鏈完整名單，盛讚台灣是「全球最好的生態系」；耐思尼名列其中，以AI機器人應用服務切入具身智慧供應鏈。",
          "date": "TechNews 科技新報 - 01 JUN 2026",
          "img": "gtc_supply_chain.png",
          "imgPosition": "bottom",
          "url": "https://www.instagram.com/p/DZCiaeqjLB0/?utm_source=ig_web_copy_link&igsh=NTc4MTIwNjQ2YQ=="
        },{
          "title": "耐思尼登上黃仁勳GTC主題演講背板 - nexuni",
          "desc": "黃仁勳GTC主題演講以台灣為中心的背板「狂點290家夥伴」，耐思尼名列其中，成為輝達展示台灣AI生態系的代表企業之一。",
          "date": "ETtoday新聞雲 - 01 JUN 2026",
          "img": "gtc_keynote_backdrop.png",
          "url": "https://finance.ettoday.net/news/3175542"
        },{
          "title": "Physical AI重構製造生產效率 - nexuni",
          "desc": "鴻海、達梭與耐思尼解析產線自主化的落地實踐；耐思尼以數位分身與Sim-to-Real技術，打造「感知、推理、行動」三步驟循環的具身智慧，讓AI走出螢幕、走進工廠。",
          "date": "TechOrange 科技報橘 - 04 MAY 2026",
          "img": "physical_ai_techorange.jpg",
          "url": "https://techorange.com/2026/05/04/physical-ai-foxconn-dassault-nexuni/"
        },{
          "title": "具身智慧落地 耐思尼搶攻千億級機器人市場 - nexuni",
          "desc": "耐思尼以具身智慧為核心，攜AI巡邏機器狗等四款機器人參展2026智慧城市展，已接洽20多家潛在合作夥伴，展現機器人在城市管理與產業巡檢的實際應用價值",
          "date": "工商時報 - 30 MAR 2026",
          "img": "ctee_post2.jpg",
          "url": "https://www.ctee.com.tw/news/20260330700746-431202"
        },{
          "title": "益登科技亮相NVIDIA GTC 2026 - nexuni",
          "desc": "益登科技攜手耐思尼於GTC 2026展出雙臂機器人，透過少量樣本學習完成毛巾折疊",
          "date": "DIGITIMES - 17 MAR 2026",
          "img": "gtc2026.jpg",
          "url": "https://www.digitimes.com.tw/tech/dt/n/shwnws.asp?cnlid=13&cat=100&id=0000749349_UHQ2Y46I5ERH5Z8PY544B"
        },{
          "title": "巡邏機器狗深入救災第一線 - nexuni",
          "desc": "非凡財經新聞報導耐思尼AI巡邏機器狗如何深入救災現場，取代人力執行高風險巡邏任務",
          "date": "非凡財經新聞 - 17 MAR 2026",
          "img": "youtube_dog.png",
          "url": "https://youtu.be/Rp599UXdI7U?t=273"
        },{
          "title": "當AI機器人走進真實場域 - nexuni",
          "desc": "耐思尼首秀智慧城市展，帶來四款具身智慧機器人，涵蓋安防巡邏、工廠焊接、高空作業與服務型機器人",
          "date": "工商時報 - 16 MAR 2026",
          "img": "ctee_post.png",
          "url": "https://www.ctee.com.tw/news/20260316701024-431202"
        },{
          "title": "智慧停車柱啟用 - nexuni",
          "desc": "頭份2路段智慧停車柱啟用，採手機支付繳費",
          "date": "客家新聞 - 02 JAN 2025",
          "img": "pp_news.png",
          "url": "https://www.hakkatv.org.tw/news-detail/1735792217766922"
        },{
          "title": "創業名人堂 - nexuni",
          "desc": "書中邀請各領域創業家，紀錄nexuni和其他品牌的源起、企業經營，和創業過程中曾遇到的困難",
          "date": "灣闊文化 - 01 SEP 2022",
          "img": "news10.jpg",
          "url": "PDF"
        },{
          "title": "校園新創人企劃",
          "desc": "Sponya新企畫來啦!校園新創人企劃將訪問在學生時代就已經創業的青年創業家。",
          "date": "Sponya - 21 JUL 2021",
          "img": "sponya.jpg",
          "url": "https://www.facebook.com/sponya.tw/posts/pfbid0SKanwvpjNA39BMP3kuhH7iFKzJdi62BhRm8R5AQZEuxR27st7ZRSWVVc4TZQZQM1l"
        },
        {
          "title": "自動化商店 - 豆日子",
          "desc": "「米其林主廚超市」引進明星甜品店 DoDay Pro 豆日子進駐微風超市南山",
          "date": "中時 - 07 APR 2021",
          "img": "news3.png",
          "url": "https://www.chinatimes.com/realtimenews/20210407004050-260405?chdtv"
        }]
      }]

    }
}

    this.setState({
      web_content: intern_content[page_title]["web_content"]
    })
  }

}

export default GeneralPage;

